import React, { Component } from "react";
import Pusher from "pusher-js";
import moment from "moment";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import PrinterService from "../../services/printer";
import Colors, { getKOTBgColor, getKOTTextColor } from "../../common/Colors";
import { Box } from "@mui/material";
import { convertFromRaw } from "draft-js"
import { stateToHTML } from "draft-js-export-html"
import ConfirmationModal from "../../components/ConfirmationModal";
import IsolatedStatusModal from "../../components/StatusModal";
import { FormControl, Select, MenuItem, Grid, Button, TextField, CircularProgress, IconButton, InputAdornment } from "@mui/material";
import SwitchTable from "../../components/SwitchTable";
import Floors from "./Components/Floors";
import Tables from "./Components/Tables";
import SearchFood from "./Components/SearchFood";
import FoodCard from "./Components/FoodCard";
import CategoryCard from "./Components/CategoryCardWithoutIcon";
import { getCurrency, Capitalize } from "../../common/util";
import Toast from "../../components/Toast";
import CloseIcon from '@mui/icons-material/Close';
import SpecialProductModal from "../../components/SpecialProductModal";
import { base_url } from "../../services/API";
import AutoPrintKOT from "../../components/AutoPrintKOT";

import { root_url } from "../../services/API";
import { initSocket } from "../../services/socket";
class DineInScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      closeOrderVisible: false,
      editOrderVisible: false,
      switchTableOpen: false,
      orderId: null,
      catagoriesWithMenu: [],
      search: "",
      searchResult: [],
      tables: [],
      selectTablePopup: true,
      selectedTable: {},
      cart: [],
      paidBy: "cash",
      checkInDate: null,
      checkOutDate: null,
      kotPrintInProgress: false,
      showCustomerModal: false,
      newCustomerMobile: '',
      newCustomerName: '',
      in_house_payment:false,
                orderInfo: null,

      newCustomerEmail: '',
      isCheckingMobile: false,
      mobileCheckError: null,
      billPrintInProgress: false,

      subTotal: 0,
      discount: 0,
      gst: 0,
      gstPer: 0.18,
      total: 0,
      floors: [],
      cartMode: "add", //add  kot
      auto_kot_print: false,
      auto_bill_print: false,
      kot: [],
      SelectedTableOrderData: {},
      user: {},
      // ------------------------
      selectedCatagoryIndex: 0,
      selectedTableId: 0,
      paymentMode: "cash",
      paymentModes: [],

      currency: "",
      isConfirmationModalOpen: false,
      isModalOpen: false,
      modalType: "success", // or "error"
      modalTitle: "",
      modalMessage: "",
      modalButtonText: "Close",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },


      // Special product modal state
      specialProductModalOpen: false,
      selectedSpecialProduct: null,

    }
              this.printerService = null;

    this.autoPrintRef = React.createRef()
    // Initialize Pusher
    this.pusher = new Pusher("7f819db2246b3e22af39", {
      cluster: "ap2",
      forceTLS: true,
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  openConfirmationModal = () => {
    this.setState({ isConfirmationModalOpen: true })
  }

  closeConfirmationModal = () => {
    this.setState({ isConfirmationModalOpen: false })
  }

  openModal = (type, title, message, buttonText = "Close", callback = null) => {
    this.setState({
      isModalOpen: true,
      modalType: type,
      modalTitle: title,
      modalMessage: message,
      modalButtonText: buttonText,
      modalCallback: callback,
    })
  }

  closeModal = () => {
    const { modalCallback } = this.state
    this.setState({
      isModalOpen: false,
    })

    if (modalCallback) {
      modalCallback()
    }
  }

  // Open special product modal
  openSpecialProductModal = (item) => {
    this.setState({
      specialProductModalOpen: true,
      selectedSpecialProduct: item,
    })
  }

  // Close special product modal
  closeSpecialProductModal = () => {
    this.setState({
      specialProductModalOpen: false,
      selectedSpecialProduct: null,
    })
  }

  // Add special product to cart
  addSpecialProductToCart = (item) => {
    const cart = [...this.state.cart]
    cart.push(item)

    this.setState({ cart }, () => {
      this.calculates()
    })
  }

  deSelectTable = (after = null) => {
    this.setState(
      {
        selectedTableId: 0,
        selectedTableNo: "",
        selectedTableVacant: false,
        SelectedTableOrderData: {},
        user: {},
        addItems: false,
        selectedTable: {},
      },
      () => {
        if (after) after()
      },
    )
  }

  async componentDidMount() {

    try {
      const { selectedHotelId } = this.props;
      if (!selectedHotelId || !selectedHotelId.id || !selectedHotelId.currency) {
        console.error("❌ Invalid hotel information in props: ", selectedHotelId);
        return;
      }

      const currency = getCurrency(selectedHotelId.currency) + " ";
      this.setState({ currency });

      const floors = await this.getFloors();  // ⏳ Wait for floors to load
      console.log("Floors fetched:", floors);
      const hotelId = String(this.props.selectedHotelId.id);
      if (!hotelId) {
        console.error('❌ No hotelId available - cannot subscribe to channels');
        return;
      }
      
      console.log('🔌 Initializing socket connection for hotel:', hotelId);
      this.socket = initSocket(hotelId);
      this.printerService = new PrinterService(this.socket);

      if (floors.length > 0) {
        this.getHotelCatagoriesWithMenu(floors[0].id);  // ✅ Now safe to call
      } else {
        console.warn("⚠️ No floors found");
      }

      this.getPaymentModes();

      if (!this.pusher) {
        console.error("❌ Pusher instance is not defined.");
        return;
      }

      this.pusher.connection.bind("connected", () => {
        console.log("✅ Pusher connected successfully");
      });

      this.pusher.connection.bind("error", (err) => {
        console.error("❌ Pusher connection error: ", err);
      });

      this.subscribeToSocketIOChannels();
    } catch (error) {
      console.error("❌ Error in componentDidMount: ", error);
    }
  }

// Declare the subscribeToOrderUpdates method before using it
subscribeToOrderUpdates = (orderId) => {
  if (!orderId || !this.socket) {
    console.log("❌ Cannot subscribe - missing orderId or socket connection")
    return
  }

  // Unsubscribe from previous orders with detailed logging
  if (this.currentOrderSubscription) {
    console.log(`🔕 Unsubscribing from previous order: ${this.currentOrderSubscription}`)
    this.socket.off(this.currentOrderSubscription)
  }
  if (this.currentOrderSubscription1) {
    console.log(`🔕 Unsubscribing from previous order status: ${this.currentOrderSubscription1}`)
    this.socket.off(this.currentOrderSubscription1)
  }

  // Order updated event
  const eventName = `etable_database_user.order_updated.${orderId}:hotel-events`
  console.log(`🔔 Subscribing to order updates: ${eventName}`)

  this.socket.on(eventName, (data) => {
    console.group("📦 Order Update Received")
    console.log("📡 Event:", eventName)
    console.log("📅 Timestamp:", new Date().toISOString())
    console.log("📊 Data:", data)
    console.groupEnd()

    this.getTableOrders(this.state.selectedTableId)
  })

  // Order status updated event - THIS IS THE KEY FIX
  const eventName1 = `etable_database_user.order_status_updated.${orderId}:hotel-events`
  console.log(`🔔 Subscribing to order status updates: ${eventName1}`)

  this.socket.on(eventName1, (data) => {
    console.group("📦 Order Status Update Received")
    console.log("📡 Event:", eventName1)
    console.log("📅 Timestamp:", new Date().toISOString())
    console.log("🔄 Status Data:", data)
    console.groupEnd()

    // Extract the actual order data from the socket event
    const orderData = data?.data?.data || data?.data || data

    if (orderData && orderData.hotel_order_id) {
      // Check if this status update is for the currently selected table's order
      const currentOrderId = this.state.SelectedTableOrderData?.id

      if (String(orderData.hotel_order_id) === String(currentOrderId)) {
        console.log("✅ tatus update matches current order - refreshing table orders",this.state.selectedTableId)
        this.getTableOrders(this.state.selectedTableId)
      } else {
        console.log("ℹ️ Status update for different order - no action needed")
      }
    } else {
      // Fallback: refresh anyway if we can't determine the order ID
      console.log("⚠️ Could not determine order ID from status update - refreshing anyway")
      this.getTableOrders(this.state.selectedTableId)
    }
  })

  this.currentOrderSubscription = eventName
  this.currentOrderSubscription1 = eventName1
}

  
  subscribeToSocketIOChannels = () => {
    try {
      
      if (!this.socket) {
        console.error('❌ Socket initialization failed');
        return;
      }
        const hotelId = String(this.props.selectedHotelId.id);

      // Connection events with enhanced logging
      this.socket.off("connect");
      this.socket.on("connect", () => {
        console.group('🟢 Socket.IO Connection Established');
        console.log('🏨 Hotel ID:', hotelId);
        console.log('🆔 Socket ID:', this.socket.id);
        console.log('🕒 Connected at:', new Date().toISOString());
        console.groupEnd();
      });
  
      this.socket.off("disconnect");
      this.socket.on("disconnect", (reason) => {
        console.group('🔴 Socket.IO Disconnected');
        console.log('🏨 Hotel ID:', hotelId);
        console.log('📛 Reason:', reason);
        console.log('🕒 Disconnected at:', new Date().toISOString());
        console.groupEnd();
      });
  
      this.socket.off("reconnect");
      this.socket.on("reconnect", (attempt) => {
        console.group('🟡 Socket.IO Reconnected');
        console.log('🏨 Hotel ID:', hotelId);
        console.log('🔢 Attempt:', attempt);
        console.log('🕒 Reconnected at:', new Date().toISOString());
        console.groupEnd();
      });
  
      // Event subscriptions with detailed logging
      const events = [
        { event: "select_normal_table", handler: this.handleTableSelection },
        { event: "select_join_table", handler: this.newJoinTableBookedFromUser },
        { event: "release_table", handler: this.handleTableRelease },
        { event: "call_waiter", handler: this.waiterCalledFromUser },
        { event: "dinein", handler: this.handleDineInEvent },
                { event: "payment_cash", handler: this.handlePaymentEvent }

      ];
  
      events.forEach(({ event, handler }) => {
        const fullEvent = `etable_database_hotel.${event}.${hotelId}:hotel-events`;
        
        // Unsubscribe first to avoid duplicates
        this.socket.off(fullEvent);
        
        if (typeof handler === 'function') {
          console.log(`🔔 Subscribing to hotel event: ${fullEvent}`);
          this.socket.on(fullEvent, (data) => {
            console.group(`🏨 Hotel Event: ${event}`);
            console.log('📡 Full Event:', fullEvent);
            console.log('📅 Timestamp:', new Date().toISOString());
            console.log('📊 Data:', data);
            console.groupEnd();
            
            handler(data);
          });
        } else {
          console.error(`❌ Invalid handler for event ${event} - not a function`);
        }
      });
  
      // KOT event with enhanced logging
      const kotEvent = `etable_database_hotel.kot.${hotelId}:hotel-events`;
      this.socket.off(kotEvent);
      console.log(`🔔 Subscribing to KOT events: ${kotEvent}`);
      this.socket.on(kotEvent, (data) => {
        console.group('🍽️ KOT Event Received');
        console.log('📡 Event:', kotEvent);
        console.log('📅 Timestamp:', new Date().toISOString());
        console.log('📝 KOT Data:', data);
        console.groupEnd();
        this.handleKOTEvent(data)
      });
  
      console.log('✅ Successfully subscribed to all Socket.IO channels');
  
    } catch (error) {
      console.group('❌ Error in subscribeToSocketIOChannels');
      console.error('Error:', error);
      console.trace('Stack trace:');
      console.groupEnd();
    }
  };
  handleKOTEvent = (data) => {
    console.log("📡 KOT Event Received:", data);
    
    // Extract KOT data from the event
    const kotData = data?.data.data;
    
    if (!kotData) {
      console.log("❌ No KOT data found in event");
      return;
    }
    
    const { hotel_order_id, hotel_id, id: kotId } = kotData;
    
    // Check if this KOT belongs to the currently selected table's order
    if (this.state.selectedTableId && this.state.SelectedTableOrderData?.id) {
      const currentOrderId = this.state.SelectedTableOrderData.id;
      
      console.log("🔍 Checking KOT relevance:", {
        kotOrderId: hotel_order_id,
        currentOrderId: currentOrderId,
        selectedTableId: this.state.selectedTableId
      });
      
      // If the KOT belongs to the current table's order, refresh the table orders
      if (String(hotel_order_id) === String(currentOrderId)) {
        console.log("✅ KOT belongs to current table - refreshing orders");
        this.getTableOrders(this.state.selectedTableId);
      } else {
        console.log("ℹ️ KOT belongs to different order - no action needed");
      }
    } else {
      console.log("ℹ️ No table selected or no active order");
    }
  };
// Add this new handler function
handleDineInEvent = (data) => {
  console.log("📡 DineIn Event Received:", data);
  // Handle the dinein event here
  // For example, you might want to refresh table orders or update UI
  console.log(data?.data,"Im hereeeeeeee111111",this.state.selectedTableId)

  if (data?.data.event === 'dinein' && this.state.selectedTableId) {
    console.log("Im hereeeeeeee")
    this.getTableOrders(this.state.selectedTableId);
  }
};
handlePaymentEvent = (data) => {
  try {
    const parsedData = typeof data === "string" ? JSON.parse(data) : data;
    console.log("💰 Payment Event Received:parsedData", parsedData);

    if (parsedData.data.type === "object" && parsedData.data.event === "payment_cash" && this.state.selectedTableId == parsedData.data.data.hotel_table_id) {
      const paymentData = parsedData.data.data;
          console.log("Im hereeeeeeee")
      this.getTableOrders(this.state.selectedTableId)
      this.setState({
        in_house_payment: true,
        orderInfo: {
          order_id: paymentData.id, // Using the order ID from payment data
          payment_method: paymentData.payment_method || "cash",
          amount: paymentData.order_grand_total, // Using order_grand_total as amount
          customer: paymentData.user || {}
        }
      });

      // Clear payment after 2 minutes if not handled
      if (this.paymentTimeout) clearTimeout(this.paymentTimeout);
      this.paymentTimeout = setTimeout(() => {
        this.setState({
          in_house_payment: false,
          orderInfo: null
        });
      }, 120000); // 2 minutes
    }
  } catch (error) {
    console.error("❌ Error parsing payment Socket.IO data:", error);
  }
}

  setupChannel = (channel, eventName, handler) => {
    if (!channel) {
      console.error("❌ Channel is undefined for event binding.")
      return
    }

    channel.bind("pusher:subscription_succeeded", () => {
      console.log(`✅ Subscribed to ${channel.name}`)
    })

    channel.bind("pusher:subscription_error", (error) => {
      console.error(`❌ Subscription error: `, error)
    })

    channel.bind(eventName, (data) => {
      console.log(`📡 Event Received from ${channel.name} - ${eventName}: `, data)

      try {
        const parsedData = typeof data === "string" ? JSON.parse(data) : data

        if (parsedData.type === "data" && handler) {
          handler(parsedData.data)
        } else if (parsedData.type === "message") {
          this.props.okDialog(parsedData.message)
        } else {
          console.warn("🔴 Unknown event type: ", parsedData.type)
        }
      } catch (error) {
        console.error("❌ Error parsing Pusher data: ", error)
        console.log("🔴 Raw Data: ", data)
      }
    })
  }

  waiterCalledFromUser = (data) => {
    const { id: table_id, hotel_floor_id = 0, table_status = 0, call_waiter = 0 } = data

    if (this.state.selectedFloorId == hotel_floor_id) {
      this.setState({
        tables: this.state.tables.map((table) => {
          if (table.id == table_id) {
            table = { ...table, call_waiter }
          }
          return table
        }),
      })

      if (this.state.selectedTableId == table_id) {
        //this.state.selectedTable.call_waiter
        this.setState({
          selectedTable: {
            ...this.state.selectedTable,
            call_waiter,
          },
        })
      }
    } else {
      this.setChnageInFloorFlag(hotel_floor_id)
    }
  }
  setChnageInFloorFlag = (hotel_floor_id) => {
    const { floors } = this.state
    floors.map((floor) => {
      if (floor.id == hotel_floor_id) {
        floor.call_waiter = 1
      }
      return floor
    })
    this.setState({
      floors,
    })
  }
  handleTableRelease = (data) => {
    const { id } = data.data.data
    this.getTables(this.state.selectedFloorId)
    this.getFloors(true)
    if (this.state.selectedTableId === id) {
      this.deSelectTable()
    }
  }
    handleTableSelection = (data) => {
    console.log("heeeeeeeeeeeeeeeeeeeeeeeeeeeee", data.data.data)
    const { id: table_id, hotel_floor_id = 0, table_status = 0 } = data.data.data
    console.log(
      "Table selected:",
      table_id,
      "Floor ID:",
      hotel_floor_id,
      "Status:",
      table_status,
      "this.state.selectedFloorId",
      this.state.selectedFloorId,
    )

    if (this.state.selectedFloorId == hotel_floor_id) {
      this.setState(
        {
          tables: this.state.tables.map((table) => (table.id == table_id ? { ...table, table_status } : table)),
        },
        () => {
          // If the status change is for the currently selected table, refresh its orders
          if (this.state.selectedTableId === table_id) {
            console.log(`🔄 Table ${table_id} status changed, refreshing orders.`)
            this.getTableOrders(table_id)
          }
        },
      )
    } else {
      this.setChangeInFloorFlag(hotel_floor_id)
    }
  }

  // handleTableSelection = (data) => {
  //   const { id: table_id, hotel_floor_id = 0, table_status = 0 } = data

  //   if (this.state.selectedFloorId == hotel_floor_id) {
  //     this.setState({
  //       tables: this.state.tables.map((table) => (table.id == table_id ? { ...table, table_status } : table)),
  //     })
  //   } else {
  //     this.setChangeInFloorFlag(hotel_floor_id)
  //   }
  // }

  setChangeInFloorFlag = (hotel_floor_id) => {
    const { floors } = this.state

    const updatedFloors = floors.map((floor) => (floor.id == hotel_floor_id ? { ...floor, call_waiter: 1 } : floor))

    this.setState({ floors: updatedFloors })
  }


  handleOrderUpdate = (data) => {
    try {
      console.log("🔄 Order Update Event Received: ", data)

      const { id: order_id, hotel_table_id } = data

      if (this.state.selectedTableId === hotel_table_id) {
        console.log("✅ Matching Table ID. Fetching updated orders...")
        this.getTableOrders(hotel_table_id)
      } else {
        console.log("❌ Table ID mismatch. Ignoring update.")
      }
    } catch (error) {
      console.error("❌ Error handling order update: ", error)
    }
  }

  // Fetch table orders
  getTableOrders = async (table) => {
    console.log("tabletabletabletabletable", table);
    try {
      const { status, message, data } = await API(this, "get", URL_PATH.getTableActiveOrders(table.id ?? table));
      if (status === "success") {
        if (data.kot && data.kot.length > 0) {
          data.kot[data.kot.length - 1].expanded = true;
        }
        console.log("Fetched orders for table:", data);
        
        // Subscribe to order updates after getting the order data
        if (data.id) {
          this.subscribeToOrderUpdates(data.id);
        }
  
        this.setState({
          user: data.user ?? {},
          kot: data.kot,
          selectedTableVacant: true,
          SelectedTableOrderData: data,
          subTotal: data.order_total,
          gst: data.order_tax_total,
          gstPer: data.order_tax_percentage,
          discount: data.order_discount,
          total: data.order_grand_total,
        });
      } else {
        this.setState({
          selectedTableVacant: false,
          kot: [],
          SelectedTableOrderData: {},
        });
      }
    } catch (error) {
      console.error("Error fetching table orders:", error);
    }
  };

  getCurrentOrderStatusOrders = async (table) => {

    try {
      const { status, message, data } = await API(this, "get", URL_PATH.getCurrentOrderStatusOrders(table.id ?? table));
      if (status === "success") {
        if (data.kot && data.kot.length > 0) {
          data.kot[data.kot.length - 1].expanded = true; // Expand the latest KOT
        }
        console.log("Fetched orders for table:", data);


        this.setState({
          user: data.user ?? {},
          kot: data.kot,
          selectedTableVacant: true,
          SelectedTableOrderData: data,
          subTotal: data.order_total,
          gst: data.order_tax_total,
          gstPer: data.order_tax_percentage,
          discount: data.order_discount,
          total: data.order_grand_total,
        });
      } else {
        this.setState({
          selectedTableVacant: false,
          kot: [],
          SelectedTableOrderData: {},
        });
      }
    } catch (error) {
      console.error("Error fetching table orders:", error);
    }
  };

  handleSaveCustomer = async () => {
    const { newCustomerName, newCustomerEmail, newCustomerMobile, SelectedTableOrderData } = this.state

    // Prepare the request payload
    const customerData = {
      name: newCustomerName,
      email: newCustomerEmail,
      mobile: newCustomerMobile,
      order_id: SelectedTableOrderData.id
    }

    try {
      console.log("Saving customer data:", customerData, URL_PATH.addGuestCustomer)

      // Replace `URL_PATH.saveCustomer` with your actual API endpoint
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.addGuestCustomer,
        customerData, // Pass data in the request body
      )

      if (status === "success") {
        console.log("Customer saved successfully:", data)

        // Close the modal and optionally reset form fields
        this.setState({
          showCustomerModal: false,
          //   newCustomerName: "",
          //   newCustomerEmail: "",
          //   newCustomerMobile: "",
        })

        // Optionally refresh data or show a success message
        this.showToast("Customer details saved successfully!", "success");
      } else {
        console.error("Failed to save customer:", message)
        this.showToast(`Error: ${message}`, "error");
      }
    } catch (error) {
      console.error("API Error:", error)
      this.showToast("Failed to save customer. Please try again.", "error");
    }
  }

  newJoinTableBookedFromUser = (data) => {
    const { id: table_id, hotel_floor_id = 0, table_status = 0 } = data
    this.getTables(this.state.selectedFloorId)
    this.getFloors(true)
  }

  unsubscribeFromPusherChannels = () => {
    // Unsubscribe from all channels
    this.pusher.unsubscribe(`hotel.select_normal_table.${this.props.selectedHotelId.id}`)
    this.pusher.unsubscribe(`hotel.select_join_table.${this.props.selectedHotelId.id}`)
    this.pusher.unsubscribe(`hotel.release_table.${this.props.selectedHotelId.id}`)
    this.pusher.unsubscribe(`hotel.call_waiter.${this.props.selectedHotelId.id}`)
    this.pusher.unsubscribe(`hotel.dine_in.order_update.${this.props.selectedHotelId.id}`)
  }

  getPaymentModes = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getPaymentModes)
    if (status == "success") {
      this.setState({ paymentModes: data })
    } else {
      this.showToast(message, "error")
    }
  }

  getFloors = async (noAfter = false) => {
    const { status, message, hotelFloors } = await API(this, "get", URL_PATH.floorList(this.props.selectedHotelId.id));

    if (status === "success") {
      return new Promise((resolve) => {
        this.setState({ floors: hotelFloors }, () => {
          if (hotelFloors.length > 0 && !noAfter) {
            this.getTables(hotelFloors[0].id);
          }
          resolve(hotelFloors);
        });
      });
    } else {
      this.showToast(message, "error");
      return [];
    }
  };

  getTables = async (floorId) => {
    if (floorId !== 0 && !floorId) return console.log("floor id is invalid", floorId)
    console.log("floorId", floorId)

    this.setState({ selectedFloorId: floorId })

    try {
      let response

      if (floorId === "all") {
        console.log("for all")
        response = await API(this, "get", URL_PATH.listAllTablesForHotel(this.props.selectedHotelId.id))
      } else {
        console.log("for floor")
        response = await API(this, "get", URL_PATH.listTable(floorId))
      }

      const { status, message, data } = response

      if (status === "success") {
        console.log("Condition passes")

        // Handle different data structures for "all" and specific floors
        const tablesData = Array.isArray(data) ? data : data.data

        const filteredData = tablesData.map((item) => ({
          ...item,
          table_status: item.table_status ?? 1,
        }))

        console.log("filtered data", filteredData)

        this.setState({ tables: filteredData }, () => {
          if (filteredData.length > 0) {
            const firstTable = filteredData[0]
            this.setState(
              {
                selectedTable: firstTable,
                selectedTableNo: firstTable.table_no,
                selectedTableId: firstTable.id,
              },
              () => this.getTableOrders(firstTable.id),
            )
          }
        })
      }
    } catch (error) {
      console.error("Error fetching tables:", error)
    }
  }

  getHotelCatagoriesWithMenu = async (spaceId) => {
    // If spaceId is "all", use the first floor's ID, otherwise use the provided spaceId


    console.log("this.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.propsthis.props",this.props)
    const finalSpaceId = spaceId === "all" && this.state.floors.length > 0
      ? this.state.floors[0].id
      : spaceId;

    const headers = {
      'space-id': finalSpaceId  // Use the determined space ID in the header
    };

    try {
      const { status, message, data } = await API(
        this,
        "get",
        URL_PATH.getHotelCatagoriesWithMenu(this.props.selectedHotelId.id),
        {},        // data (empty object because GET request doesn't need body)
        headers    // header with the appropriate space-id
      );

      if (status === "success") {
        this.setState({ catagoriesWithMenu: data });
      } else {
        this.showToast(message, "error");
      }
    } catch (error) {
      this.showToast("Failed to fetch categories with menu", "error");
      console.error("Error fetching categories with menu:", error);
    }
  };

  handleSuccess = () => {
    this.setState({ switchTableOpen: false })
  }

  create = async () => {
    //validate all input fields conatining value

    var formdata = new FormData(document.getElementById("hotelForm"))

    formdata.append("rawMaterial", JSON.stringify(""))
    const { status, message, data } = await API(this, "post", URL_PATH.createInventoryInvoice, formdata)
    if (status == "success") {
      this.openModal("success", "Success", message, "OK", () => {
        this.props.history.push(routes.admin.invoices.list)
      })
    } else {
      this.showToast(message, "error")
    }
  }

  search = async () => {
    try {
      clearTimeout(this.searchBounce)
    } catch (e) {
      console.error("Error clearing timeout:", e)
    }
    if (!this.state.search.trim()) {
      this.setState({ searchResult: [] })
      return
    }


    this.searchBounce = setTimeout(async () => {
      const url = URL_PATH.hotelMenuSearch(this.props.selectedHotelId.id, this.state.search)
      console.log("Request URL:", url)

      try {
        const response = await API(this, "get", url)

        console.log("Full API Response:", response)

        if (!response || typeof response !== "object") {
          console.error("Invalid API response format:", response)
          this.showToast("Unexpected API response")
          return
        }

        const { status, message, data } = response

        if (status === "success") {
          console.log("Data received:", data)
          this.setState({ searchResult: data })
        } else {
          console.error("Error message:", message || "Unknown error")
          this.showToast(message, "error")
        }
      } catch (error) {
        console.error("API call failed:", error)
        this.showToast("API request failed")
      }
    }, 500)
  }

  calculates = () => {
    let subtotal = 0

    // Calculate subtotal including special items
    this.state.cart.forEach((item) => {
      console.log("Calculating price for cart item:", item.menu_name,
        "currentPrice:", item.currentPrice,
        "menu_price:", item.menu_price,
        "isSpecial:", item.isSpecial,
        "itemTotalPrice:", item.itemTotalPrice,
        "quantity:", item.quantity)

      if (item.isSpecial) {
        // For special items, use the calculated itemTotalPrice
        // We're already setting currentPrice in the modal for special items
        subtotal += item.itemTotalPrice * item.quantity
        console.log("Special item total:", item.itemTotalPrice * item.quantity)
      } else if (item.currentPrice) {
        // For items with area pricing or custom pricing
        subtotal += item.currentPrice * item.quantity
        console.log("Using currentPrice:", item.currentPrice * item.quantity)
      } else {
        // For regular items, use the standard calculation
        subtotal += item.menu_price * item.quantity
        console.log("Using menu_price:", item.menu_price * item.quantity)
      }
    })

    const gst = subtotal * (this.state.gstPer / 100)
    const total = subtotal + gst

    this.setState({
      subTotal: subtotal,
      gst: gst,
      total: total,
    })
  }


  addToCart = (item) => {
    console.log("Adding to cart:", item)

    const getEffectivePrice = (item) => {
      const activeArea = item.area_details?.find(area => area.area_status === true);
      return activeArea ? activeArea.area_final_price : item.menu_price;
    };

    const hasSpecialDetails =
      item.special_details &&
      ((item.special_details.detailseAttribute && item.special_details.detailseAttribute.length > 0) ||
        (item.special_details.detailseAddonFields && item.special_details.detailseAddonFields.length > 0));

    // If it's a special item with attributes/addons but hasn't been processed yet
    if (hasSpecialDetails && !item.isSpecial) {
      this.openSpecialProductModal(item);
      return;
    }

    const cart = [...this.state.cart]; // Create a copy of the cart array

    // For special items, we need to find an exact match including special attributes
    if (item.isSpecial) {
      // Try to find an existing special item with the same ID and special attributes
      const index = cart.findIndex((x) =>
        x.id === item.id &&
        x.isSpecial &&
        JSON.stringify(x.special_details) === JSON.stringify(item.special_details)
      );

      if (index === -1) {
        cart.push({ ...item, quantity: 1, currentPrice: item.currentPrice || getEffectivePrice(item) });
      } else {
        cart[index].quantity++;
      }
    } else {
      // For normal items
      const index = cart.findIndex((x) => x.id === item.id && !x.isSpecial);
      const effectivePrice = getEffectivePrice(item);

      if (index === -1) {
        cart.push({ ...item, quantity: 1, isSpecial: false, currentPrice: effectivePrice });
      } else {
        cart[index].quantity++;
      }
    }

    this.setState({ cart }, () => {
      this.calculates();
    });
  }


  removeFromCart = (item) => {
    const cart = this.state.cart
    const index = cart.findIndex(
      (x) =>
        x.id == item.id &&
        x.isSpecial === item.isSpecial &&
        JSON.stringify(x.selectedAttributes) === JSON.stringify(item.selectedAttributes) &&
        JSON.stringify(x.selectedAddons) === JSON.stringify(item.selectedAddons),
    )

    if (index != -1) {
      cart.splice(index, 1)
    }
    this.setState(
      {
        cart,
      },
      () => this.calculates(),
    )
  }


  debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  handleMobileNumberChange = async (e) => {
    const mobileNumber = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    this.setState({
      newCustomerMobile: mobileNumber,
      isCheckingMobile: true,
      mobileCheckError: null
    });

    // Only make API call if mobile number has 10 digits
    if (mobileNumber.length <= 10) {
      this.checkMobileNumber(mobileNumber);
    } else {
      this.setState({ isCheckingMobile: false });
    }
  };

  // Debounced version of the API call
  checkMobileNumber = this.debounce(async (mobileNumber) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${base_url}/user/check-mobile`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'hotel-id': this.props.selectedHotelId.id,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mobile: mobileNumber })
      });

      const data = await response.json();

      if (data.status === "exists_in_hotel" && data.data) {
        // Auto-fill the form with user details
        this.setState({
          newCustomerName: data.data.name || '',
          newCustomerEmail: data.data.email || '',
          newCustomerMobile:data.data.mobile ,
          isCheckingMobile: false
        });
      } else if (data.status === "exists_globally" && data.data) {
        // Auto-fill the form with user details
        this.setState({
          newCustomerName: data.data.name || '',
          newCustomerEmail: data.data.email || '',

          isCheckingMobile: false
        });
      } else {
        this.setState({
          isCheckingMobile: false,
          mobileCheckError: data.message || 'User not found'
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      this.setState({
        isCheckingMobile: false,
        mobileCheckError: 'Failed to check mobile number'
      });
    }
  }, 500); // 500ms debounce delay


 saveOrder = async (shouldPrint = true) => {
    const cart = this.state.cart;
    console.log("New KOT cart", cart);

    if (cart.length === 0) {
      return this.showToast("Please add items to cart");
    }


    const orderItems = cart.map((item) => {
      // Find the area details for this menu item from your menu data
      let areaDetails = null;

      // Try to find the current item in catagoriesWithMenu data
      if (this.state.catagoriesWithMenu) {
        for (const category of this.state.catagoriesWithMenu) {
          if (category.hotel_menu) {
            const menuItem = category.hotel_menu.find(menu => menu.id === item.id);
            if (menuItem && menuItem.area_details && menuItem.area_details.length > 0) {
              // Use the first area detail (assuming "AC Hall" is what we want)
              areaDetails = menuItem.area_details[0];
              break;
            }
          }
        }
      }

      // Create the order item with its ID and quantity
      const orderItem = {
        id: item.id,
        item_quantity: item.quantity
      };

      // Add area details to each item if found
      if (areaDetails) {
        orderItem.area_name = areaDetails.area_name;
        orderItem.area_price_type = areaDetails.area_price_type;
        orderItem.area_type_wise_value = areaDetails.area_type_wise_value;
        orderItem.area_status = areaDetails.area_status;
      }

      // Handle special items with customizations
      if (item.isSpecial && item.special_details) {
        const specialData = {};

        if (item.selectedAttributes?.length) {
          specialData.variation_data = {};
          item.selectedAttributes.forEach((attr) => {
            specialData.variation_data[attr.name] = attr.value;
          });
        }

        if (item.basePrice) {
          specialData.variation_total = item.basePrice;
        }

        if (item.selectedAddons?.length) {
          specialData.add_ons_data = {};
          let addonTotal = 0;
          item.selectedAddons.forEach((addonGroup) => {
            if (Array.isArray(addonGroup.options)) {
              addonGroup.options.forEach((addon) => {
                if (addon?.name && addon?.price != null) {
                  specialData.add_ons_data[addon.name] = addon.price;
                  addonTotal += addon.price;
                }
              });
            }
          });
          specialData.addon_total = addonTotal;
        }

        if (item.specialRequest) {
          specialData.special_request = item.specialRequest;
        }

        if (item.itemTotalPrice) {
          specialData.final_total = item.itemTotalPrice;
        }

        orderItem.special_item_data = specialData;
      }

      return orderItem;
    });

    const order = {
      order_id: this.state.SelectedTableOrderData.id,
      floor_id: this.state.selectedFloorId,
      table_id: this.state.selectedTableId,
      items: orderItems
    };

    console.log("Final Order Payload:", order);

    const { status, message, data } = await API(this, "post", URL_PATH.addFoodToTable, order);
console.log("datadata",data)
    // After successful order save
    if (status === "success") {
      this.setState({ cart: [] });
              this.handleAutoPrint(data);

      // Wait 1 second before fetching KOT list
      // Replace the existing KOT fetching logic with this:
      setTimeout(async () => {
        const kotResponse = await API(this, "get", URL_PATH.listKOTV2(this.props.selectedHotelId.id));
        if (kotResponse.status === "success") {
          let kotList = kotResponse.data;

          // Based on your API response, the structure should be kotResponse.data.kot
          // But since you're calling listKOTV2, let's handle both possible structures
          if (kotList && typeof kotList === 'object') {
            // If the response has a 'kot' property (like your table orders response)
            if (kotList.kot && Array.isArray(kotList.kot)) {
              kotList = kotList.kot;
            }
            // If the response has a 'kots' property (possible from listKOTV2)
            else if (kotList.kots && Array.isArray(kotList.kots)) {
              kotList = kotList.kots;
            }
            // If kotList is already an array
            else if (Array.isArray(kotList)) {
              // kotList is already correct
            }
            // If it's some other structure, try to find an array
            else {
              console.error("Unexpected KOT response structure:", kotList);
              kotList = [];
            }
          } else {
            console.error("Invalid KOT response:", kotList);
            kotList = [];
          }

          console.log("kotList array:", kotList);
          console.log("SelectedTableOrderData.id", this.state.SelectedTableOrderData.id);

          // Only proceed if kotList is now an array
          if (Array.isArray(kotList) && kotList.length > 0) {
            const matchingPendingKots = kotList.filter(k => {
              const kotOrderId = String(k.hotel_order_id).trim();
              const selectedOrderId = String(this.state.SelectedTableOrderData.id).trim();
              const status = k.status?.trim().toLowerCase();

              return kotOrderId === selectedOrderId && status === "pending";
            });

            console.log("matchingPendingKots", matchingPendingKots);

            const lastKot = matchingPendingKots[matchingPendingKots.length - 1];

            console.log("KOT list after delay:", lastKot && shouldPrint);

            if (lastKot && shouldPrint) {
              this.handleAutoPrint(lastKot);
            }
          } else {
            console.log("No KOTs found or kotList is empty");
          }

          // Refresh table orders
          this.getTableOrders(this.state.selectedTableId);
        } else {
          console.error("Failed to fetch KOT list:", kotResponse.message);
        }
      }, 0); // 1 second delay// 1 second delay
    } else {
      this.showToast("Failed to save order.", "error");
    }
  };



  //   saveOrder = async (savePrompt = true) => {
  //     const cart = this.state.cart;
  //     console.log("New KOT cart", cart);


  //     if (cart.length === 0) {
  //       return this.showToast("Please add items to cart");
  //     }

  //     const orderItems = cart.map((item) => {
  //       const orderItem = {
  //         id: item.id,
  //         item_quantity: item.quantity,
  //       };

  //       if (item.isSpecial && item.special_details) {
  //         const specialData = {};

  //         if (item.selectedAttributes?.length) {
  //           specialData.variation_data = {};
  //           item.selectedAttributes.forEach((attr) => {
  //             specialData.variation_data[attr.name] = attr.value;
  //           });
  //         }

  //         if (item.basePrice) {
  //           specialData.variation_total = item.basePrice;
  //         }

  //         if (item.selectedAddons?.length) {
  //           specialData.add_ons_data = {};
  //           let addonTotal = 0;
  //           item.selectedAddons.forEach((addonGroup) => {
  //             if (Array.isArray(addonGroup.options)) {
  //               addonGroup.options.forEach((addon) => {
  //                 if (addon?.name && addon?.price != null) {
  //                   specialData.add_ons_data[addon.name] = addon.price;
  //                   addonTotal += addon.price;
  //                 }
  //               });
  //             }
  //           });
  //           specialData.addon_total = addonTotal;
  //         }

  //         if (item.specialRequest) {
  //           specialData.special_request = item.specialRequest;
  //         }

  //         if (item.itemTotalPrice) {
  //           specialData.final_total = item.itemTotalPrice;
  //         }

  //         orderItem.special_item_data = specialData;
  //       }

  //       return orderItem;
  //     });

  //     const order = {
  //       order_id: this.state.SelectedTableOrderData.id,
  //       floor_id: this.state.selectedFloorId,
  //       table_id: this.state.selectedTableId,
  //       items: orderItems,
  //       area_name: "AC Hall",
  //       area_price_type: "fix",
  //       area_type_wise_value: 10,
  //       area_status: true
  //     };

  //     console.log("Final Order Payload:", order);

  //     const { status, message, data } = await API(this, "post", URL_PATH.addFoodToTable, order);

  //   // After successful order save
  //  if (status === "success") {
  //     this.setState({ cart: [] });
  // const currentTableId = this.state.selectedTableId;
  // await this.getTableOrders(this.state.selectedTableId);
  //     // Wait for KOT list and then auto-print
  //    setTimeout(async () => {
  //       const kotResponse = await API(this, "get", URL_PATH.listKOTV2(this.props.selectedHotelId.id));

  //       if (kotResponse.status === "success") {
  //         const kotData = kotResponse.data;
  //         console.log("KOT response data:", kotData);

  //         if (savePrompt && kotData.dinein?.pending) {
  //           const pendingKots = kotData.dinein.pending;

  //           // For empty tables, match by table_id instead of order_id
  //           const matchingKots = pendingKots.filter(k => {
  //             // First try to match by order_id if available
  //             if (this.state.SelectedTableOrderData?.id) {
  //               return String(k.hotel_order_id) === String(this.state.SelectedTableOrderData.id);
  //             }
  //             // Fallback: match by table_id and recent creation time
  //             return String(k.hotel_table_id) === String(currentTableId) && 
  //                    new Date(k.created_at) > new Date(Date.now() - 60000); // Within last minute
  //           });

  //           // Get the latest KOT
  //           const lastKot = matchingKots[matchingKots.length - 1];

  //           if (lastKot) {
  //             console.log("Auto-printing KOT:", lastKot);
  //             this.handleAutoPrint(lastKot);
  //           } else {
  //             console.log("No matching KOT found for auto-print");
  //             console.log("Available KOTs:", pendingKots);
  //             console.log("Current table ID:", currentTableId);
  //             console.log("Current order ID:", this.state.SelectedTableOrderData?.id);
  //           }
  //         }
  //       }
  //     }, 500); // Increased delay to 2 seconds for empty tables
  //   } else {
  //     this.showToast(message || "Failed to save order.", "error");
  //   }
  // };
  createBlackAndWhiteKOT = (item) => {
    return `
  <div style="padding: 10px;  max-width: 80mm;">
    <!-- KOT Header -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; border-bottom: 2px solid #000; padding-bottom: 5px;">
      <div style="font-size: 18px; font-weight: bold;">KOT #${item.id}</div>
      <div style="font-size: 14px; font-weight: bold;">${moment(item.created_at).format("DD-MM-YY HH:mm")}</div>
    </div>

    <!-- Order Info -->
    <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
      <div>
        <div style="font-size: 12px; color: #555;">ORDER ID</div>
        <div style="font-size: 16px; font-weight: bold;">${item.hotel_order_id}</div>
      </div>
      
     <div>
          <div style="font-size: 12px; color: #555;">SPACE</div>
          <div style="font-size: 14px; font-weight: bold;">${item.space || "N/A"}</div>
        </div>
    </div>

    ${item.hotel_order?.order_type === "dinein" ? `
      <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">

       <div style="text-align: left;">
        <div style="font-size: 12px; color: #555;">TYPE</div>
        <div style="font-size: 16px; font-weight: bold; text-transform: uppercase;">
          ${item.hotel_order?.order_type === "dinein" ? "DINE-IN" :
          item.hotel_order?.order_type === "takeaway" ? "TAKEAWAY" : "DELIVERY"}
        </div>
      </div>
        
        <div>
          <div style="font-size: 12px; color: #555;">TABLE</div>
          <div style="font-size: 14px; font-weight: bold;">${item.joinedFirst3Tables || "N/A"}</div>
        </div>
      </div>
    ` : ''}

    ${item.hotel_order?.order_type === "takeaway" ? `
      <div style="margin-bottom: 12px;">
        <div style="font-size: 12px; color: #555;">PICKUP TIME</div>
        <div style="font-size: 14px; font-weight: bold;">
          ${item.hotel_order?.order_due_date_time ?
          moment(item.hotel_order?.order_due_date_time).format("DD-MM-YY HH:mm A") : "ASAP"}
        </div>
      </div>
    ` : ''}

    <!-- Items List -->
    <div style="margin-top: 15px; border-top: 2px dashed #000; padding-top: 8px;">
      <table style="width: 100%; border-collapse: collapse;">
        ${item.kot_items.map((menuItem) => {
            let specialDataHtml = "";

            // Parse special_data if it exists
            if (menuItem.special_data) {
              try {
                const specialData = menuItem.special_data;

                // Variations
                if (specialData.variation_data) {
                  specialDataHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 5px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">VARIATION:</div>
                      <div style="margin-left: 5px;">
                        ${Object.entries(specialData.variation_data)
                      .map(([key, value]) => `• ${key}: <span style="font-weight: bold;">${value}</span>`)
                      .join("<br>")}
                      </div>
                    </td>
                  </tr>`;
                }

                // Add-ons
                if (specialData.add_ons_data && Object.keys(specialData.add_ons_data).length > 0) {
                  specialDataHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 5px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">ADD-ONS:</div>
                      <div style="margin-left: 5px;">
                        ${Object.keys(specialData.add_ons_data)
                      .map(name => `• ${name}`)
                      .join("<br>")}
                      </div>
                    </td>
                  </tr>`;
                }

                // Special request
                if (specialData.special_request) {
                  specialDataHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 10px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">SPECIAL REQUEST:</div>
                      <div style="margin-left: 5px; font-style: italic;">
                        ${specialData.special_request}
                      </div>
                    </td>
                  </tr>`;
                }
              } catch (e) {
                console.error("Error parsing special data:", e);
              }
            }

            return `
            <tr>
              <td style="padding: 8px 0; font-size: 16px; font-weight: bold; vertical-align: top; width: 15%; border-bottom: 1px solid #eee;">
                ${menuItem.item_quantity}x
              </td>
              <td style="padding: 8px 0; font-size: 16px; font-weight: bold; vertical-align: top; border-bottom: 1px solid #eee;">
                ${menuItem.item_menu_name}
                ${specialDataHtml}
              </td>
            </tr>
          `;
          }).join("")}
      </table>
    </div>

    ${item.note ? `
      <div style="margin-top: 15px; padding: 8px; border: 1px dashed #000; font-size: 14px;">
        <div style="font-weight: bold; margin-bottom: 5px;">ORDER NOTE:</div>
        <div>${item.note}</div>
      </div>
    ` : ''}

    <!-- Footer -->
    <div style="margin-top: 15px; text-align: center; font-size: 12px; color: #555; border-top: 2px solid #000; padding-top: 8px;">
      Printed: ${moment().format("DD-MM-YY HH:mm:ss")}
    </div>
  </div>
`;
  }

  handleAutoPrint = (kotData) => {
    try {
      const printWindow = window.open("", "PRINT", "height=600,width=400");
      if (!printWindow) {
        console.error("Failed to open print window");
        return;
      }

      printWindow.document.write(`
  <html>
    <head>
      <title>KOT Print</title>
      <style>
        @media print {
          body {
            margin: 0;
            padding: 10px;
            font-family: Arial, sans-serif;
            width: 80mm;
            -webkit-print-color-adjust: exact;
          }
          * {
            box-sizing: border-box;
          }
        }
        body {
          margin: 0;
          padding: 10px;
          font-family: Arial, sans-serif;
          width: 80mm;
        }
        .kot-container {
          padding: 10px;
          max-width: 80mm;
        }
        .kot-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          border-bottom: 2px solid #000;
          padding-bottom: 5px;
        }
        .kot-id {
          font-size: 18px;
          font-weight: bold;
        }
        .order-id {
          font-size: 16px;
          font-weight: bold;
        }
        .order-info {
          display: flex;
          justify-content: space-between;
          margin-top: 2px;
        }
        .order-type {
          font-size: 12px;
          color: #555;
        }
        .order-type-value {
          font-size: 16px;
          font-weight: bold;
          text-transform: uppercase;
        }
        .space-info {
          font-size: 14px;
          font-weight: bold;
          text-align: right;
        }
        .items-list {
          margin-top: 15px;
          border-top: 2px dashed #000;
          padding-top: 8px;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
        }
        .item-row td {
          padding: 8px 0;
          font-size: 16px;
          font-weight: bold;
          vertical-align: top;
          border-bottom: 1px solid #eee;
        }
        .item-quantity {
          width: 15%;
        }
        .variation-section, .addons-section {
          padding-left: 15px;
          padding-bottom: 5px;
          font-size: 12px;
        }
        .special-request {
          padding-left: 15px;
          padding-bottom: 10px;
          font-size: 12px;
          font-style: italic;
        }
        .order-note {
          margin-top: 15px;
          padding: 8px;
          border: 1px dashed #000;
          font-size: 14px;
        }
        .kot-footer {
          margin-top: 5px;
          text-align: center;
          font-size: 12px;
          color: #555;
          border-top: 2px solid #000;
          padding-top: 8px;
        }
        .footer-time {
          font-size: 14px;
          font-weight: bold;
        }
      </style>
    </head>
    <body>
      <div class="kot-container">
        <!-- KOT Header -->
        <div class="kot-header">
          <div class="kot-id">KOT #${kotData.kot_number}</div>
          <div class="order-id">ORDER ID: ${kotData.order_number}</div>
        </div>

        <!-- Order Info -->
        <div class="order-info">
          ${kotData.hotel_order?.order_type === "dinein" ? `
            <div>
              <div class="order-type">TYPE</div>
              <div class="order-type-value">
                ${kotData.hotel_order?.order_type === "dinein" ? "DINE-IN" :
            kotData.hotel_order?.order_type === "takeaway" ? "TAKEAWAY" : "DELIVERY"}
              </div>
            </div>
          ` : ""}
          
          ${kotData.hotel_order?.order_type === "takeaway" ? `
            <div>
              <div class="order-type">PICKUP TIME</div>
              <div class="order-type-value">
                ${kotData.hotel_order?.order_due_date_time ?
            moment(kotData.hotel_order?.order_due_date_time).format("DD-MM-YY HH:mm A") : "ASAP"}
              </div>
            </div>
          ` : ""}
          
          <div class="space-info">
            <div>${kotData.space || "N/A"}</div>
            <div>${kotData.joinedFirst3Tables || "N/A"}</div>
          </div>
        </div>

        <!-- Items List -->
        <div class="items-list">
          <table class="items-table">
            ${kotData.kot_items.map((menuItem) => {
              let specialDataHtml = "";
              if (menuItem.special_data) {
                try {
                  const specialData = menuItem.special_data;

                  if (specialData.variation_data) {
                    specialDataHtml += `
                      <tr>
                        <td colspan="2" class="variation-section">
                          <div style="font-weight: bold; margin-bottom: 2px;">VARIATION:</div>
                          <div style="margin-left: 5px;">
                            ${Object.entries(specialData.variation_data)
                        .map(([key, value]) => `• ${key}: <span style="font-weight: bold;">${value}</span>`)
                        .join("<br>")}
                          </div>
                        </td>
                      </tr>`;
                  }

                  if (specialData.add_ons_data && Object.keys(specialData.add_ons_data).length > 0) {
                    specialDataHtml += `
                      <tr>
                        <td colspan="2" class="addons-section">
                          <div style="font-weight: bold; margin-bottom: 2px;">ADD-ONS:</div>
                          <div style="margin-left: 5px;">
                            ${Object.keys(specialData.add_ons_data)
                        .map((name) => `• ${name}`)
                        .join("<br>")}
                          </div>
                        </td>
                      </tr>`;
                  }

                  if (specialData.special_request) {
                    specialDataHtml += `
                      <tr>
                        <td colspan="2" class="special-request">
                          <div style="font-weight: bold; margin-bottom: 2px;">SPECIAL REQUEST:</div>
                          <div style="margin-left: 5px;">
                            ${specialData.special_request}
                          </div>
                        </td>
                      </tr>`;
                  }
                } catch (e) {
                  console.error("Error parsing special data:", e);
                }
              }

              return `
                <tr class="item-row">
                  <td class="item-quantity">${menuItem.item_quantity}x</td>
                  <td>
                    ${menuItem.item_menu_name}
                    ${specialDataHtml}
                  </td>
                </tr>
              `;
            }).join("")}
          </table>
        </div>

        ${kotData.note ? `
          <div class="order-note">
            <div style="font-weight: bold; margin-bottom: 5px;">ORDER NOTE:</div>
            <div>${kotData.note}</div>
          </div>
        ` : ""}

        <!-- Footer -->
        <div class="kot-footer">
          <div class="footer-time">${moment(kotData.created_at).format("DD-MM-YY HH:mm")}</div>
        </div>
      </div>
      <script>
        setTimeout(() => {
          window.print();
          setTimeout(() => window.close(), 500);
        }, 200);
      </script>
    </body>
  </html>
`);

      printWindow.document.close();
    } catch (err) {
      console.error("Failed to auto-print:", err);
    }
  }
  // saveOrder = async (savePrompt = true) => {
  //   const cart = this.state.cart;
  //   console.log("New KOT cart", cart);

  //   if (cart.length === 0) {
  //     return this.showToast("Please add items to cart");
  //   }

  //   const orderItems = cart.map((item) => {
  //     const orderItem = {
  //       id: item.id,
  //       item_quantity: item.quantity,
  //     };

  //     // If the item is a special item, format its special_item_data
  //     if (item.isSpecial && item.special_details) {
  //       const specialData = {};

  //       // Variation data from selectedAttributes
  //       if (item.selectedAttributes?.length) {
  //         specialData.variation_data = {};
  //         item.selectedAttributes.forEach((attr) => {
  //           specialData.variation_data[attr.name] = attr.value;
  //         });
  //       }

  //       // Variation total
  //       if (item.basePrice) {
  //         specialData.variation_total = item.basePrice;
  //       }

  //       // Addons data
  //       if (item.selectedAddons?.length) {
  //         specialData.add_ons_data = {};
  //         item.selectedAddons.forEach((addonGroup) => {
  //           if (Array.isArray(addonGroup.options)) {
  //             addonGroup.options.forEach((addon) => {
  //               if (addon?.name && addon?.price != null) {
  //                 specialData.add_ons_data[addon.name] = addon.price;
  //               }
  //             });
  //           }
  //         });


  //         // Addon total
  //         specialData.addon_total = item.selectedAddons.reduce((sum, addon) => sum + addon.price, 0);
  //       }

  //       // Special request (optional)
  //       if (item.specialRequest) {
  //         specialData.special_request = item.specialRequest;
  //       }

  //       // Final total
  //       if (item.itemTotalPrice) {
  //         specialData.final_total = item.itemTotalPrice;
  //       }

  //       orderItem.special_item_data = specialData;
  //     }

  //     return orderItem;
  //   });

  //   const order = {
  //     order_id: this.state.SelectedTableOrderData.id,
  //     floor_id: this.state.selectedFloorId,
  //     table_id: this.state.selectedTableId,
  //     items: orderItems,
  //   };

  //   console.log("Final Order Payload:", order);

  //   const { status, message, data } = await API(this, "post", URL_PATH.addFoodToTable, order);
  //   if (status === "success") {
  //     this.setState({ cart: [] });
  //     this.getTableOrders(this.state.selectedTableId);
  //   }
  // };


  renderKot = () => {
    const cart = this.state.cart
    return (
      <div
        id={"kot"}
        className=" col-lg-3 p-3"
        style={{
          display: "none",
          margin: 10,
          backgroundColor: Colors.pageBgColor,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>{this.props.selectedHotelId.hotel_name}</h4>
          </div>
          <div
            style={{
              paddingBottom: "5px",
              borderBottom: "1px solid black",
              marginBottom: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {this.state.orderId}
              <br />
              Order Id
              {"" == "dinein" ? "Dine In" : "Take Away"}
            </div>
            <div
              style={{
                textAlign: "center",
              }}
            >
              KOT
            </div>
            <div
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {moment().format("HH:mm")}
              <br />
              Time
            </div>
          </div>

          <Box className="card-subtitle" style={{ textAlign: "center", fontSize: "15px" }}>
            {this.state.selectedTable.table_no}
          </Box>

          {/* menus */}
          <div
            style={{
              marginTop: "5px",
              paddingTop: "5px",
              borderTop: "1px solid black",
            }}
          >
            <div
              style={{
                textAlign: "center",
                borderBottom: "1px solid black",
              }}
            >
              Order Summary
            </div>
            <table width="100%">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Item</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr
                    style={{
                      borderBottom: "1px dotted black",
                    }}
                  >
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td>
                      {item.menu_name}
                      {item.isSpecial && (
                        <div style={{ fontSize: "0.8em", fontStyle: "italic" }}>
                          {item.selectedAttributes &&
                            item.selectedAttributes.map((attr, i) => (
                              <div key={i}>
                                {attr.name}: {attr.value}
                              </div>
                            ))}
                          {item.selectedAddons &&
                            item.selectedAddons.map((addon, i) => (
                              <div key={i}>
                                {addon.fieldName}: {addon.options.map((opt) => opt.name).join(", ")}
                              </div>
                            ))}
                        </div>
                      )}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {item.quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  renderBill = () => {
    const cart = this.state.cart
    return (
      <div
        id={"bill"}
        className=" col-lg-3 p-3"
        style={{
          margin: 10,
          backgroundColor: Colors.pageBgColor,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div style={{ borderBottom: "solid 2px black" }}>
            <h4 style={{ textAlign: "center", fontWeight: "bold" }}>{this.props.selectedHotelId.hotel_name}</h4>
            <h6 style={{ textAlign: "center" }}>{this.props.selectedHotelId.address}</h6>
          </div>
          <div
            style={{
              borderBottom: "2px solid black",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              padding: "5px 0px",
            }}
          >
            <div
              style={{
                //horizontally center elements
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              #{this.state.orderId}
            </div>
            <div
              style={{
                //horizontally center elements
                textAlign: "center",
              }}
            >
              {moment().format("YYYY-MM-DD hh:mm A")}
            </div>
          </div>

          <div className="card-subtitle" style={{ textAlign: "center" }}>
            {this.state.selectedTable.table_no}
          </div>

          {this.state.cart.length > 0 && (
            <table width="100%">
              <thead>
                <tr
                  style={{
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    padding: "3px 0px",
                  }}
                >
                  <th>Items</th>
                  <th>Rate</th>
                  <th>Q</th>
                  <th>₹₹</th>
                </tr>
              </thead>
              <tbody>
                {this.state.cart.map((item, index) => (
                  <tr
                    style={{
                      borderBottom: "1px solid black",
                    }}
                  >
                    <td>
                      {item.menu_name}
                      {item.isSpecial && (
                        <div style={{ fontSize: "0.8em", fontStyle: "italic" }}>
                          {item.selectedAttributes &&
                            item.selectedAttributes.map((attr, i) => (
                              <div key={i}>
                                {attr.name}: {attr.value}
                              </div>
                            ))}
                          {item.selectedAddons &&
                            item.selectedAddons.map((addon, i) => (
                              <div key={i}>
                                {addon.fieldName}: {addon.options.map((opt) => opt.name).join(", ")}
                              </div>
                            ))}
                        </div>
                      )}
                    </td>
                    <td>{item.isSpecial ? (item.itemTotalPrice / item.quantity).toFixed(2) : item.menu_price}</td>
                    <td
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {item.quantity}
                    </td>
                    <td>₹{item.isSpecial ? item.itemTotalPrice : item.menu_price * item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Total gst spc discount  */}
          <div
            style={{
              borderBottom: "solid 2pz black",
            }}
          >
            {/* Total */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              {/* Subtotal */}
              <div>Subtotal</div>
              <div>₹{this.state.subTotal}</div>
            </div>
            {/* GST */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              {/* Subtotal */}
              <div>GST(%)</div>
              <div>{this.state.gstPer}%</div>
            </div>

            {/* SPC */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              <div>Spe. Dis.(₹)</div>
              <div>₹0</div>
            </div>
          </div>
          {/* Total and paid with */}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "5px",
              fontWeight: "bold",
            }}
          >
            <div>Total</div>
            <div>₹{this.state.total}</div>
          </div>
          <div style={{ textAlign: "center" }}>(Paid with UPI)</div>
          <hr />
          <div style={{ textAlign: "center" }}>
            Thank you!
            <br />
            Please Visist Us Again!
          </div>
        </div>
      </div>
    )
  }

  printKot = async (bill = false) => {
    await this.saveOrder(false)

    if (bill == false) await this.setState({ kotPrintInProgress: true })
    else await this.setState({ billPrintInProgress: true })

    const printContents = document.getElementById(bill ? "bill" : "kot").innerHTML

    // document.getElementById("kot").style.display = "block";

    var windowUrl = "about:blank"
    var uniqueName = new Date()
    var windowName = "Print" + uniqueName.getTime()

    var printWindow = window.open(windowUrl, windowName, "left=0,top=0,width=0,height=0")

    printWindow.document.write(printContents)
    printWindow.document.close()
    printWindow.focus()
    printWindow.print()
    printWindow.close()

    // document.getElementById("kot_action_" + item.id).style.display = "flex";
    // document.getElementById("kot_" + item.id).style.margin = "10px";
    // document.getElementById("kot_logo_" + item.id).style.display = "none";

    this.setState({ kotPrintInProgress: false, billPrintInProgress: false })
  }

  // calculates = () => {
  //   let subtotal = 0

  //   // Calculate subtotal including special items
  //   this.state.cart.forEach((item) => {
  //     if (item.isSpecial) {
  //       // For special items, use the calculated itemTotalPrice
  //       subtotal += item.itemTotalPrice
  //     } else {
  //       // For regular items, use the standard calculation
  //       subtotal += item.menu_price * item.quantity
  //     }
  //   })

  //   const gst = subtotal * (this.state.gstPer / 100)
  //   const total = subtotal + gst

  //   this.setState({
  //     subTotal: subtotal,
  //     gst: gst,
  //     total: total,
  //   })
  // }

  decreaseQuantity = (item) => {
    const cart = this.state.cart
    const index = cart.findIndex(
      (x) =>
        x.id == item.id &&
        x.isSpecial === item.isSpecial &&
        JSON.stringify(x.selectedAttributes) === JSON.stringify(item.selectedAttributes) &&
        JSON.stringify(x.selectedAddons) === JSON.stringify(item.selectedAddons),
    )

    if (index != -1) {
      if (cart[index].quantity == 1) return cart.splice(index, 1)
      cart[index].quantity--
    }

    this.setState(
      {
        cart,
      },
      () => this.calculates(),
    )
  }

  deSelectTable = (after = null) => {
    this.setState(
      {
        selectedTableId: 0,
        selectedCatagoryId: -1,
        selectedTableNo: "",
        selectedTableVacant: false,
        SelectedTableOrderData: {},
        user: {},
        addItems: false,
        selectedTable: {},
        closeOrderVisible: false,
      },
      () => {
        if (after) after()
      },
    )
  }

  getWidth = () => {
    return window.innerWidth
  }

  RenderItems = ({ item, index }) => {
    const {
      id,
      kot_id,
      hotel_menu_id,
      item_menu_name,
      item_quantity,
      hotel_menu_price,
      special_data, // This contains the special item details
    } = item

    // Handle all possible cases for special_data
    let specialDetails = null
    let isSpecial = false

    try {
      // Case 1: special_data is null or undefined
      if (!special_data) {
        specialDetails = null
      }
      // Case 2: special_data is the string "null"
      else if (special_data === "null") {
        specialDetails = null
      }
      // Case 3: special_data is already an object
      else if (typeof special_data === "object") {
        specialDetails = special_data
        isSpecial = true
      }
      // Case 4: special_data is a JSON string
      else if (typeof special_data === "string") {
        const parsed = JSON.parse(special_data)
        // Check if parsed result is null or an empty object
        if (parsed && typeof parsed === "object" && Object.keys(parsed).length > 0) {
          specialDetails = parsed
          isSpecial = true
        }
      }
    } catch (error) {
      console.error("Error parsing special_data:", error, special_data)
      specialDetails = null
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          alignSelf: "center",
          padding: "10px",
          paddingBottom: "20px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#041A29",
              height: "30px",
              width: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p style={{ color: "white", fontSize: "16px", margin: 0 }}>{index + 1}</p>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <p style={{
              fontSize: "16px",
              display: "flex",
              alignItems: "center", // vertical centering
              height: "100%", // needs a defined height
              margin: 0 // remove default margins
            }}>
              {item_quantity} x {item_menu_name}
            </p>

            {/* Display variations and addons for special items */}
            {isSpecial && specialDetails && (
              <div style={{ fontSize: "12px", color: "#aaa", marginTop: "2px" }}>
                {/* Display variations */}
                {specialDetails.variation_data &&
                  Object.entries(specialDetails.variation_data).map(([key, value], i) => (
                    <div key={`var-${i}`}>
                      {key}: {value}
                    </div>
                  ))}

                {/* Display special requests if exists */}

                {/* Display addons if exists */}
                {/* {specialDetails.add_ons_data &&
                  Array.isArray(specialDetails.add_ons_data) &&
                  specialDetails.add_ons_data.length > 0 && (
                    <div>
                      Add-ons:{" "}
                      {specialDetails.add_ons_data
                        .map((addon) => addon.option_name || addon.name || "Add-on")
                        .join(", ")}
                    </div>
                  )} */}
                {specialDetails.add_ons_data &&
                  typeof specialDetails.add_ons_data === 'object' &&
                  Object.keys(specialDetails.add_ons_data).length > 0 && (
                    <div>
                      Add-ons:{" "}
                      {Object.entries(specialDetails.add_ons_data)
                        .map(([name, price]) => `${name} (₹${price})`)
                        .join(", ")}
                    </div>
                  )}
                {specialDetails.special_request && <div>Request: {specialDetails.special_request}</div>}

              </div>
            )}
          </div>
        </div>

        <div style={{ marginTop: "2px" }}>
          <p style={{
            color: "white",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",  // Vertical centering
            height: "100%",       // Needs explicit height from parent
            margin: 0,            // Remove default margins
            padding: 0            // Remove default padding
          }}>
            {this.state.currency}
            {hotel_menu_price}
          </p>
        </div>
      </div>
    )
  }

  changeKotStatus = async (status, kot_id) => {
    return

    const { status: responseStatus, message } = await API(this, "post", URL_PATH.changeKotStatus, { status, kot_id })
    if (responseStatus == "success") {
      this.getTableOrders(this.state.selectedTableId)
    } else {
      this.openModal("error", "Error", message)
    }
  }

  saveKOTStatus = async (item, status) => {
    const {
      status: status1,
      message,
      data,
    } = await API(this, "post", URL_PATH.updateKOTStatus, {
      kot_id: item.id,
      status: status,
    })
    if (status1 != "success") {
      return this.openModal("error", "Error", message)
    }

    this.getTableOrders(this.state.selectedTableId)
  }

  OrderDetails = () => {
    const { SelectedTableOrderData, user } = this.state

    const { id, user_id, order_grand_total,order_number } = SelectedTableOrderData
    const { name = "Unknown", email = null, mobile = "NA" } = user
    console.log("SelectedTableOrderDataSelectedTableOrderData", SelectedTableOrderData, "this.state.selectedTableId", this.state.selectedTableId, "s.state.selectedTableVacant", this.state.selectedTableVacant)

    if (this.state.selectedTableId != 0 && this.state.selectedTableVacant == false && this.state.cart.length == 0) {
      return (
        <div className="container">
          <div
            className="order-details  p-2 d-flex justify-center align-items-center flex-column"
            style={{
              minHeight: "68vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 20,
                marginTop: 40,
              }}
            >
              <img
                src="https://static-dev.etableapp.com/app-assets/illus/cartEmpty.png"
                width={250}
                height={250}
                alt="Empty Cart"
              />
            </div>

            <div>
              <p
                className="d-block"
                style={{
                  color: Colors.primary,
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                {" "}
                Start Order
              </p>
            </div>
            <div>
              <p
                style={{
                  textAlign: "center",
                }}
              >
                Once you add items from a resturant or cafe, your order will appear here.
              </p>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="container">
        {id && name && (
          <div className="order-details" style={{ position: "sticky", overflow: "hidden", zIndex: 1 }}>
            <p>Order No: {order_number}</p>
            <p>
              Customer:{" "}
{(name === "Guest user" || name === "Walk-In Customer") && !this.state.newCustomerName && !this.state.newCustomerMobile ? (
    <>
        {name}
        <button
            onClick={() => this.setState({ showCustomerModal: true })}
            style={{
                marginLeft: "10px",
                padding: "4px 8px",
                backgroundColor: "#FFC857",
                color: "#02111B",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: "700",
            }}
        >
            + Add Customer Details
        </button>
    </>
) : name === "Guest user" || name === "Walk-In Customer" ? (
    `${this.state.newCustomerName} - ${this.state.newCustomerMobile}`
) : (
    `${name} - ${mobile}`
)}  
            </p>
          </div>
        )}

        {/* Customer Details Modal */}
        {this.state.showCustomerModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "#02111B",
                padding: "25px",
                borderRadius: "12px",
                width: "380px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.28)",
                border: "none",
                position: "relative",
                overflow: "hidden",
                "&:before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: "linear-gradient(90deg, #FFC857 0%, #E6B54E 100%)",
                },
              }}
            >
              {/* Close Icon */}
              <IconButton
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  color: "white",
                  zIndex: 1,
                }}
                onClick={() => this.setState({ showCustomerModal: false })}
              >
                <CloseIcon />
              </IconButton>

              <h4
                style={{
                  color: "white",
                  marginTop: "0",
                  marginBottom: "20px",
                  fontSize: "18px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                Add Customer Details
              </h4>
              <TextField
                label="Mobile Number"
                variant="outlined"
                fullWidth
                value={this.state.newCustomerMobile}
                onChange={this.handleMobileNumberChange}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { color: "rgba(255, 255, 255, 0.8)" },
                }}
                InputProps={{
                  endAdornment: this.state.isCheckingMobile ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : null,
                  style: {
                    color: "white",
                    backgroundColor: "#02111B",
                  },
                }}
                helperText={this.state.mobileCheckError}
                FormHelperTextProps={{
                  style: { color: this.state.mobileCheckError ? '#f44336' : 'rgba(255, 255, 255, 0.8)' }
                }}
                style={{ marginBottom: "25px" }}
              />

              {/* Name Field (now auto-filled when mobile is recognized) */}
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                value={this.state.newCustomerName}
                onChange={(e) => this.setState({ newCustomerName: e.target.value })}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { color: "rgba(255, 255, 255, 0.8)" },
                }}
                InputProps={{
                  style: {
                    color: "white",
                    backgroundColor: "#02111B",
                  },
                }}
                style={{ marginBottom: "20px" }}
              />

              {/* Email Field (now auto-filled when mobile is recognized) */}
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                value={this.state.newCustomerEmail}
                onChange={(e) => this.setState({ newCustomerEmail: e.target.value })}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { color: "rgba(255, 255, 255, 0.8)" },
                }}
                InputProps={{
                  style: {
                    color: "white",
                    backgroundColor: "#02111B",
                  },
                }}
                style={{ marginBottom: "20px" }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => this.setState({ showCustomerModal: false })}
                  style={{
                    padding: "8px 18px",
                    backgroundColor: "#BB0A21",
                    color: "white",

                    borderRadius: "6px",
                    fontSize: "12px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={this.handleSaveCustomer}
                  style={{
                    padding: "8px 18px",
                    backgroundColor: "#FFC857",
                    color: "black",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "700",
                    "&:hover": {
                      backgroundColor: "#E6B54E",
                    },
                  }}
                >
                  Save Details
                </Button>
              </div>
            </div>
          </div>
        )}
        {this.state.selectedTable.call_waiter === 1 && (
          <div
            className="waiter-request-container"
            style={{
              position: "fixed",
              top: "20px",
              right: window.innerWidth <= 570 ? "10px" : "70px",
              zIndex: 1000,
              animation: "pulse 2s infinite",
              maxWidth: window.innerWidth <= 570 ? "calc(100vw - 20px)" : "calc(100vw - 70px)",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                backgroundColor: "#041A29",
                color: "white",
                borderRadius: "8px",
                padding: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                display: "flex",
                alignItems: "center",
                minWidth: "280px",
                borderLeft: "4px solid #FFC857",
                position: "relative", // Added for positioning the close button
              }}
            >
              <div
                style={{
                  marginRight: "12px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#FFC857",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 13H17V7H15V13H5V15H15V19H17V15H19V13Z" fill="#041A29" />
                    <path d="M7 9H9V11H7V9Z" fill="#041A29" />
                    <path d="M11 9H13V11H11V9Z" fill="#041A29" />
                    <path d="M3 9H5V11H3V9Z" fill="#041A29" />
                  </svg>
                </div>
                {this.state.waiterSent && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-4px",
                      right: "-4px",
                      backgroundColor: "#00A651",
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px solid #041A29",
                    }}
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white" />
                    </svg>
                  </div>
                )}
              </div>

              <div style={{ flex: 1, paddingRight: "20px" }}>
                {" "}
                {/* Added padding to prevent text overlap */}
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    marginBottom: "4px",
                  }}
                >
                  {this.state.waiterSent ? "Waiter Dispatched" : "Assistance Requested"}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    opacity: 0.8,
                  }}
                >
                  {this.state.waiterSent
                    ? `Table ${this.state.selectedTable.table_no} is being assisted`
                    : `Table ${this.state.selectedTable.table_no} needs assistance`}
                </div>
              </div>

              <button
                onClick={() => {
                  this.setState({ waiterSent: true })
                  // Here you would typically make an API call to confirm the waiter was sent
                }}
                style={{
                  backgroundColor: this.state.waiterSent ? "#00A651" : "#FFC857",
                  color: "#041A29",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  marginLeft: "8px",
                  transition: "all 0.2s ease",
                  ":hover": {
                    opacity: 0.9,
                  },
                }}
              >
                {this.state.waiterSent ? "Completed" : "Acknowledge"}
              </button>
            </div>

            <style>{`
      @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.02); }
        100% { transform: scale(1); }
      }
    `}</style>
          </div>
        )}
        <hr />
      </div>
    )
  }

  getCheckoutDetails = async () => {
    const activeOrder = this.state.SelectedTableOrderData.id;

    const response = await API(this, "get", URL_PATH.checkoutCustomOrder(activeOrder));
    console.log("responsessss", response);

    // Check for error status
    if (response.status === "error") return this.openModal("error", "Error", response.message);

    // Extract data from response
    const { data } = response;

    // Handle coupon if present
    if (data.coupon) {
      this.setState({
        coupontext: "Coupon Applied",
        showcoupons: false,
        couponcode: data.coupon.coupon_code,
        couponmsg: response.message,
        maxdiscount: data.coupon.coupon_max_discount_amount,
        emptycouponmsg: "",
      });
    }

    // Determine which items to show based on cart sharing status
    let cartItems = [];
    if (data.cart_sharing_enabled && data.cart_sharing_status === "on") {
      // Combine host and shared_users items when cart sharing is on
      const hostItems = data.items.host || [];
      const sharedUserItems = data.items.shared_users || [];

      // Process shared user items (which may be nested in an items array)
      const flattenedSharedItems = sharedUserItems.reduce((acc, user) => {
        if (user.items && Array.isArray(user.items)) {
          return [...acc, ...user.items];
        }
        return acc;
      }, []);

      cartItems = [...hostItems, ...flattenedSharedItems];
    } else {
      // Use only 'all' items when cart sharing is off
      cartItems = data.items.all || [];
    }

    console.log("Cart Items:", cartItems);

    // Set state with all the data
    this.setState({
      closeOrderVisible: true,
      hotel_name: data.hotel_name,
      order_type: data.order_type,
      order_status: data.order_status,
      date: data.date,
      coupon: data.coupon,
      CartData: cartItems, // Use the determined cart items
      payments: data.payments || [],
      hotelorderid: data.order_id,
      payable_amount: data.payable_amount,
      currency: data.currency,
      onLinePayment: data.onLinePayment,
      cashPayment: data.cashPayment,
      mode: data.mode,
      cart_sharing_enabled: data.cart_sharing_enabled,
      cart_sharing_status: data.cart_sharing_status
    });

    // Handle completed payment status
    if (data.payment_status === "completed") {
      console.log("------------ status=completed");
      // this.paymentReceived("completed", this.state.hotelorderid);
    }
  };


  applyExtraDiscount = async () => {
    const { extraDiscount = "", extraDiscountType = null } = this.state

    const orderId = this.state.hotelorderid

    // if (extraDiscountType == null) return window.Alert({ title: "Please select discount type" });
    if (extraDiscount == "") return this.openModal("error", "Error", "Please enter discount")
    // const discountAmount = extraDiscountType == "percentage" ? extraDiscount : 0;

    const response = await API(this, "get", URL_PATH.applyCustomDiscount(orderId, extraDiscount))

    const { status, message } = response
    if (status == "error") {
      this.openModal("error", "Error", message)
    }
    this.setState({ extraDiscount: "", extraDiscountType: null })

    this.getCheckoutDetails()
  }

  applyWaiterTip = async () => {

    const orderId = this.state.hotelorderid
    const { waiterTip } = this.state

    // if (extraDiscountType == null) return window.Alert({ title: "Please select discount type" });
    if (waiterTip == "") return this.openModal("error", "Error", "Please enter waiter tip")
    // const discountAmount = extraDiscountType == "percentage" ? extraDiscount : 0;

    const response = await API(this, "post", `${root_url}/api/user/order/add_waiter_tip`, {
      order_id: orderId,
      waiter_tip: waiterTip
    })

    const { status, message } = response
    if (status == "error") {
      this.openModal("error", "Error", message)
    }
    this.setState({ waiterTip: "" })

    this.getCheckoutDetails()
  }


  checkout = async () => {
    this.getCheckoutDetails()
  }

  clearCart = () => {
    this.setState({
      cart: [],
    })
  }












  showReceiptDemo = () => {
    const sampleOrderData = {
      hotel_name: "Sample Hotel",
      address: "123 Main Street, City, Country",
      hotel_phones: ["123-456-7890", "098-765-4321"],
      gst: "GST123456789",
      customer_name: "John Doe",
      order_id: "ORD-12345",
      order_type: "Dine In",
      date: "2023-05-03",
      floor_no: "1st Floor",
      table_no: "Table 5",
      payment_method: "Cash",
      items: [
        {
          name: "Butter Chicken",
          description: "Creamy tomato sauce with tender chicken pieces",
          rate: 350,
          quantity: 1,
          amount: 350,
          specialItem: {
            variation_data: { "Spice Level": "Medium" },
            special_request: "Extra gravy",
            add_ons_data: { Butter: "25", "Extra Chicken": "50" },
          },
        },
        {
          name: "Garlic Naan",
          rate: 60,
          quantity: 2,
          amount: 120,
        },
      ],
      payments: [
        { key: "Subtotal", value: "470.00" },
        { key: "Tax (5%)", value: "23.50" },
        { key: "Grand Total", value: "493.50" },
      ],
    }

    this.printReceipt(sampleOrderData)
  }

  // Main receipt printing function



 getFooterHtml = (receiptFooter) => {
  if (!receiptFooter || !receiptFooter.content) {
    return `
            <div style="text-align: center; margin-top: 5px; font-style: italic; border-top: 1px dashed #000; padding-top: 10px;">
              Thank you!<br />
              Please visit us again!
            </div>
          `
  }

  const { content, images } = receiptFooter
  let htmlContent = ""
  try {
    const contentState = convertFromRaw(content)
    htmlContent = stateToHTML(contentState)
  } catch (e) {
    console.error("Error converting footer content:", e)
    htmlContent = "" // Fallback to empty string on error
  }

  let imagesHtml = ""
// imagesHtml = `  <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 5px;">
             
//                 <img
//                   src="https://static-dev.etableapp.com/receipt_footer_images/1754658608_w41cdmz8ki.png"
//                   alt="Footer Image"
//                   class="footer-image"
//                   style="max-width: 100%; object-fit: contain;"
//                 />
//             </div>`
  if (images && images.length > 0) {
    imagesHtml = `
            <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 5px;">
              ${images
                .map(
                  (img) => `
                <img
                  src="https://static-dev.etableapp.com/${img}"
                  alt="Footer Image"
                  class="footer-image"
                  style="max-width: 100%; object-fit: contain;"
                />
              `,
                )
                .join("")}
            </div>
          `
  }

  return `
          <div style="margin-top: 20px; border-top: 1px dashed #000; padding-top: 10px;">
            <div style="text-align: center; margin-top: 5px; padding-top: 10px;">
              ${htmlContent}
            </div>
            ${imagesHtml}
          </div>
        `
}

 printReceipt = (orderData, receiptFooter) => {
  const {
    hotel_name,
    address,
    hotel_phones,
    fssai_number,
    gst_number,
    customer_name,
    order_id,
    order_type,
    date,
    items,
    payments,
    payment_method,
    floor_no,
    table_no,
    logo,
  } = orderData

  const phones = Array.isArray(hotel_phones) ? hotel_phones.join(", ") : hotel_phones

  const formatSpecialData = (item) => {
    if (!item.specialItem) return ""

    const details = []
    const special = item.specialItem

    if (special.variation_data) {
      const variations = Object.entries(special.variation_data)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ")
      details.push(variations)
    }

    if (special.special_request) {
      details.push(`Special Request: ${special.special_request}`)
    }

    if (special.add_ons_data && Object.keys(special.add_ons_data).length > 0) {
      const addons = Object.entries(special.add_ons_data)
        .map(([name, price]) => `${name} (₹${price})`)
        .join(", ")
      details.push(`Add-ons: ${addons}`)
    }

    return details.length > 0 ? details.join("\n") : ""
  }

  const itemsHtml = items
    .map(
      (item) => `
  <div class="item-row">
    <div class="item-details">
      <div class="item-name">${item.name}</div>
      ${item.specialItem ? `<div class="special-info">${formatSpecialData(item)}</div>` : ""}
    </div>
    <div class="item-numbers">
      <div class="item-rate">₹${item.rate.toFixed(2)}</div>
      <div class="item-qty">${item.quantity}</div>
      <div class="item-amount">₹${item.amount.toFixed(2)}</div>
    </div>
  </div>
`,
    )
    .join("")

  const paymentsHtml = payments
    .filter((p) => p.key !== "Grand Total")
    .map(
      (p) => `
  <div class="payment-row">
    <div class="payment-key">${p.key}</div>
    <div class="payment-value">₹${Number.parseFloat(p.value.toString()).toFixed(2)}</div>
  </div>
`,
    )
    .join("")

  const finalTotal = payments.find((p) => p.key === "Grand Total")?.value || "0.00"

  // Create modal container if it doesn't exist
  let modalContainer = document.getElementById("receipt-modal-container")
  if (!modalContainer) {
    modalContainer = document.createElement("div")
    modalContainer.id = "receipt-modal-container"
    document.body.appendChild(modalContainer)
  }

  const formatPaymentMethod = (method) => {
    const map = {
      bank_transfers: "Bank Transfers",
      credit_card: "Credit Card",
      debit_card: "Debit Card",
      net_banking: "Net Banking",
    }
    return map[method] || (method ? method.charAt(0).toUpperCase() + method.slice(1).toLowerCase() : "")
  }

  const formattedPaymentMethod = formatPaymentMethod(payment_method)

  const footerHtmlContent = this.getFooterHtml(this.props.receiptFooter
)

  // Set modal HTML content
  modalContainer.innerHTML = `
  <div class="receipt-modal-overlay">
    <div class="receipt-modal-content">
      <div class="receipt-modal-header">
        <h3>Receipt Preview</h3>
        <button class="receipt-modal-close" onclick="closeReceiptModal()">&times;</button>
      </div>
      <div class="receipt-modal-body">
        <div class="receipt-container">
          <div class="logo-container">
            <img src="${
              logo ||
              "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNjY2MiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjxwYXRoIGQ9Ik0xMiA4djQiLz48cGF0aCBkPSJNMTIgMTZoLjAxIi8+PC9zdmc+"
            }" 
               alt="Logo" class="logo">
          </div>
          <div class="header">
            <div class="hotel-name">${hotel_name}</div>
            <div class="address">${address}</div>
            <div class="phone">Ph. ${phones}</div>
            <div class="gst">GSTIN: ${gst_number}</div>
            <div class="gst">FSSAI NO: ${fssai_number}</div>
          </div>

          <div class="order-info">
            <div class="info-row"><span style="font-weight: bold; font-size: 12px;">Bill To:</span> ${customer_name}</div>
            <div class="info-row"><strong>Order No:</strong> ${order_id}</div>
            <div class="info-row"><strong>Type:</strong> ${order_type.charAt(0).toUpperCase() + order_type.slice(1)}</div>              
            <div class="info-row"><strong>Ordered On:</strong> ${date}</div>
          
            <div class="floor-table"><strong>${floor_no}</strong> | <strong>${table_no}</strong></div>
          </div>

          <div class="section-title">Order Items</div>
          <div class="items-header">
            <div>ITEM</div>
            <div style="display: flex; justify-content: space-between; min-width: 120px;">
              <div>RATE</div>
              <div>QTY</div>
              <div>AMT</div>
            </div>
          </div>
          ${itemsHtml}

          <div class="section-title">Payment Summary</div>
          ${paymentsHtml}

          <div class="final-total">
            <div>Grand Total</div> <div>₹${Number.parseFloat(finalTotal.toString()).toFixed(2)}</div>
          </div>
          <div class="payment-mode">
            <div>Payment Mode</div> <div style="text-transform: uppercase;">${formattedPaymentMethod}</div>
          </div>

          ${footerHtmlContent}
        </div>
      </div>
      <div class="receipt-modal-footer">
        <button class="receipt-close-btn" onclick="closeReceiptModal()">Cancel</button>
        <button class="receipt-print-btn" onclick="printReceiptFromModal()">Print Receipt</button>
      </div>
    </div>
  </div>
`

  // Add modal styles
  const styleElement = document.createElement("style")
  styleElement.id = "receipt-modal-styles"
  styleElement.textContent = `
  .receipt-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .receipt-modal-content {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 400px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  
  .receipt-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
  }
  
  .receipt-modal-header h3 {
    margin: 0;
    font-size: 18px;
  }
  
  .receipt-modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    color: #888;
  }
  
  .receipt-modal-body {
    padding: 15px;
    overflow-y: auto;
    flex-grow: 1;
  }
  
  .receipt-modal-footer {
    padding: 15px;
    border-top: 1px solid #eee;
    text-align: right;
    display: flex;
    gap: 10px;
    justify-content:flex-end;
  }
  
  .receipt-print-btn {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
  }
  
  .receipt-print-btn:hover {
    background-color: #45a049;
  }
  
  .receipt-close-btn {
    background-color: #f44336;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
  }
  
  .receipt-close-btn:hover {
    background-color: #d32f2f;
  }
  
  /* Receipt Styles */
  .receipt-container {
    font-size: 12px;
    width: 100%;
    max-width: 80mm;
    margin: 0 auto;
    background-color: white;
    color: #000;
  }
  
  .logo-container {
    text-align: center;
    margin-bottom: 10px;
  }
  
  .logo {
    max-height: 200px;
    max-width: 200px;
    object-fit: cover;
  }
  
  .header {
    text-align: center;
    margin-bottom: 10px;
  }
  
  .hotel-name {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .address, .phone, .gst {
    margin-bottom: 3px;
  }
  
  .order-info {
    margin: 10px 0;
    border-top: 1px dashed #000;
    border-bottom: 1px dashed #000;
    padding: 5px 0;
  }
  
  .info-row {
    margin-bottom: 3px;
  }
  
  .section-title {
    font-weight: bold;
    margin: 10px 0 5px 0;
    text-align: center;
  }
  
  .item-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .item-details {
    flex: 2;
  }
  
  .item-numbers {
    display: flex;
    justify-content: space-between;
    flex: 1;
    min-width: 120px;
    text-align: right;
  }
  
  .item-name {
    font-weight: bold;
  }
  
  .item-desc, .special-info {
    font-size: 11px;
    color: #555;
    margin-top: 2px;
    white-space: pre-line;
  }
  
  .items-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: 1px solid #000;
    padding-bottom: 3px;
    margin-bottom: 5px;
  }
  
  .payment-row {
    display: flex;
    justify-content: space-between;
    margin: 3px 0;
  }
  
  .payment-key {
    font-weight: bold;
  }
  
  .final-total {
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    margin: 5px 0;
    border-top: 1px dashed #000;
    padding-top: 5px;
    display:flex;
    justify-content: space-between;
  }
  
  .floor-table {
    margin-top: 3px;
    font-weight: bold;
  }
  
  .payment-mode {
    text-align: right;
    padding-top: 5px;
    margin-bottom: 5px;
    text-transform: capitalize;
    border-top: 1px dashed #000;
    display:flex;
    justify-content: space-between;
  }
  
  .footer {
    text-align: center;
    font-style: italic;
    border-top: 1px dashed #000;
    padding-top: 10px;
  }
  
  @media print {
    .receipt-modal-overlay,
    .receipt-modal-header,
    .receipt-modal-footer {
      display: none !important;
    }
    
    .receipt-modal-content {
      box-shadow: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      max-height: none;
    }
    
    .receipt-modal-body {
      padding: 0;
      overflow: visible;
    }
    
    .receipt-container {
      max-width: none;
      color: #000 !important;
    }
    
    body {
      color: #000 !important;
    }
    
    * {
      color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

  // Add style to document if it doesn't exist
  if (!document.getElementById("receipt-modal-styles")) {
    document.head.appendChild(styleElement)
  }

  // Add global functions for modal interaction
  window.closeReceiptModal = () => {
    const modalContainer = document.getElementById("receipt-modal-container")
    if (modalContainer) {
      modalContainer.innerHTML = ""
    }
  }

  window.printReceiptFromModal = () => {
    const modalContent = document.querySelector(".receipt-container")

    if (!modalContent) {
      console.error("Modal content not found")
      return
    }

    const printWindow = window.open("", "PRINT", "height=600,width=400")

    if (!printWindow) {
      console.error("Could not open print window")
      return
    }

    printWindow.document.write(`
    <html>
      <head>
        <title>Receipt</title>
        <style>
          body {
            font-size: 12px;
            width: 80mm;
            margin: 0;
            padding: 10px;
            color: #000;
            font-family: 'Poppins', sans-serif; /* Add this line */
          }
          .hotel-name {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 5px;
          }
          .address, .phone, .gst {
            margin-bottom: 3px;
          }
          .order-info {
            margin: 10px 0;
            border-top: 1px dashed #000;
            border-bottom: 1px dashed #000;
            padding: 5px 0;
          }
          .info-row {
            margin-bottom: 3px;
          }
          .section-title {
            font-weight: bold;
            margin: 10px 0 5px 0;
            text-align: center;
          }
          .item-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
          }
          .item-details {
            flex: 2;
          }
          .item-numbers {
            display: flex;
            justify-content: space-between;
            flex: 1;
            min-width: 120px;
            text-align: right;
          }
          .item-name {
            font-weight: bold;
          }
          .item-desc, .special-info {
            font-size: 11px;
            color: #555;
            margin-top: 2px;
            white-space: pre-line;
          }
          .items-header {
            display: flex;
            justify-content: space-between;
            font-weight: bold;
            border-bottom: 1px solid #000;
            padding-bottom: 3px;
            margin-bottom: 5px;
          }
          .payment-row {
            display: flex;
            justify-content: space-between;
            margin: 3px 0;
          }
          .payment-key {
            font-weight: bold;
          }
            .final-total {
           font-size: 14px;
    font-weight: bold;
    text-align: right;
    margin: 6px 0;
    border-top: 1px dashed #000;
    padding-top: 5px;
    display:flex;
    justify-content: space-between;
          }
          .floor-table {
            margin-top: 3px;
            font-weight: bold;
          }
          .logo-container {
            text-align: center;
            margin-bottom: 10px;
          }
          .logo {
          padding-top: 10px;
           max-height: 200px;
          max-width: 200px;
          object-fit: cover;
          }
          .header {
            text-align: center;
            margin-bottom: 10px;
          }
            .payment-mode {
            text-align: right;
    margin-bottom: 7px;
    padding-top: 5px;
    text-transform: capitalize;
    border-top: 1px dashed #000;
    display:flex;
    justify-content: space-between;
          }
          .footer {
            text-align: center;
            margin-top: 5px;
            font-style: italic;
            border-top: 1px dashed #000;
            padding-top: 10px;
          }
          @media print {
            body {
              width: 80mm;
              margin: 0;
              padding: 5px;
            }
          }
        </style>
      </head>
      <body>
        ${modalContent.outerHTML}
      </body>
    </html>
  `)

    printWindow.document.close()
    printWindow.focus()

    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 500)
  }
}




printReceiptDirectly = (orderData) => {
  const {
    hotel_name,
    address,
    hotel_phones,
    gst_number,
    fssai_number,
    customer_name,
    order_id,
    order_type,
    date,
    items,
    payments,
    payment_method,
    floor_no,
    table_no,
    logo,
  } = orderData

  const phones = Array.isArray(hotel_phones) ? hotel_phones.join(", ") : hotel_phones

  const formatSpecialData = (item) => {
    if (!item.specialItem) return ""

    const details = []
    const special = item.specialItem

    if (special.variation_data) {
      const variations = Object.entries(special.variation_data)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ")
      details.push(variations)
    }

    if (special.special_request) {
      details.push(`Special Request: ${special.special_request}`)
    }

    if (special.add_ons_data && Object.keys(special.add_ons_data).length > 0) {
      const addons = Object.entries(special.add_ons_data)
        .map(([name, price]) => `${name} (₹${price})`)
        .join(", ")
      details.push(`Add-ons: ${addons}`)
    }

    return details.length > 0 ? details.join("\n") : ""
  }

  const itemsHtml = items
    .map(
      (item) => `
    <div class="item-row">
      <div class="item-details">
        <div class="item-name">${item.name}</div>
        ${item.specialItem ? `<div class="special-info">${formatSpecialData(item)}</div>` : ""}
      </div>
      <div class="item-numbers">
        <div class="item-rate">₹${item.rate.toFixed(2)}</div>
        <div class="item-qty">${item.quantity}</div>
        <div class="item-amount">₹${item.amount.toFixed(2)}</div>
      </div>
    </div>
  `,
    )
    .join("")

  const paymentsHtml = payments
    .filter(p => p.key !== "Grand Total")
    .map(
      (p) => `
    <div class="payment-row">
      <div class="payment-key">${p.key}</div>
      <div class="payment-value">₹${Number.parseFloat(p.value.toString()).toFixed(2)}</div>
    </div>
  `,
    )
    .join("");

  const finalTotal = payments.find((p) => p.key === "Grand Total")?.value || "0.00"

  const formatPaymentMethod = (method) => {
    const map = {
      bank_transfers: "Bank Transfers",
      credit_card: "Credit Card",
      debit_card: "Debit Card",
      net_banking: "Net Banking",
    };
    return map[method] || (method ? method.charAt(0).toUpperCase() + method.slice(1).toLowerCase() : "");
  };

  const formattedPaymentMethod = formatPaymentMethod(payment_method);

  const printWindow = window.open("", "PRINT", "height=600,width=400")

  if (!printWindow) {
    console.error("Could not open print window")
    return
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Receipt #${order_id}</title>
        <style>
          body {
            font-size: 12px;
            width: 80mm;
            margin: 0;
            padding: 10px;
            color: #000;
          }

          .hotel-name {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 5px;
          }
          .address, .phone, .gst {
            margin-bottom: 3px;
          }
          .order-info {
            margin: 10px 0;
            border-top: 1px dashed #000;
            border-bottom: 1px dashed #000;
            padding: 5px 0;
          }
          .info-row {
            margin-bottom: 3px;
          }
          .section-title {
            font-weight: bold;
            margin: 10px 0 5px 0;
            text-align: center;
          }
          .item-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
          }
          .item-details {
            flex: 2;
          }
          .item-numbers {
            display: flex;
            justify-content: space-between;
            flex: 1;
            min-width: 120px;
            text-align: right;
          }
          .item-name {
            font-weight: bold;
          }
          .item-desc, .special-info {
            font-size: 11px;
            color: #555;
            margin-top: 2px;
            white-space: pre-line;
          }
          .items-header {
            display: flex;
            justify-content: space-between;
            font-weight: bold;
            border-bottom: 1px solid #000;
            padding-bottom: 3px;
            margin-bottom: 5px;
          }
          .payment-row {
            display: flex;
            justify-content: space-between;
            margin: 3px 0;
          }
          .payment-key {
            font-weight: bold;
          }
          .final-total {
            font-size: 14px;
            font-weight: bold;
            text-align: right;
            margin: 10px 0;
            border-top: 1px dashed #000;
            padding-top: 5px;
            display:flex;
            justify-content: space-between;
          }
          .floor-table {
            margin-top: 3px;
            font-weight: bold;
          }
          .logo-container {
            text-align: center;
            margin-bottom: 10px;
          }
          .logo {
            height: 60px;
            width: auto;
            max-width: 200px;
            object-fit: contain;
            margin: 0 auto;
            display: block;
          }
          .header {
            text-align: center;
            margin-bottom: 10px;
          }
          .payment-mode {
            text-align: right;
            margin-bottom: 10px;
            border-top: 1px dashed #000;
            display:flex;
            justify-content: space-between;
          }
          .footer {
            text-align: center;
            margin-top: 20px;
            font-style: italic;
            border-top: 1px dashed #000;
            padding-top: 10px;
          }
        </style>
      </head>
      <body>
        <div class="receipt-container">
          <div class="logo-container">
            <img src="${logo || "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNjY2MiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjxwYXRoIGQ9Ik0xMiA4djQiLz48cGF0aCBkPSJNMTIgMTZoLjAxIi8+PC9zdmc+"}" 
               alt="Logo" class="logo">
          </div>
          <div class="header">
            <div class="hotel-name">${hotel_name}</div>
            <div class="address">${address}</div>
            <div class="phone">Ph. ${phones}</div>
            <div class="gst">GSTIN: ${gst_number}</div>
            <div class="gst">FSSAI NO: ${fssai_number}</div>
          </div>

          <div class="order-info">
            <div class="info-row"><span style="font-weight: bold; font-size: 12px;">Bill To:</span> ${customer_name}</div>
            <div class="info-row"><strong>Order No:</strong> ${order_id}</div>
<div class="info-row"><strong>Type:</strong> ${order_type.charAt(0).toUpperCase() + order_type.slice(1)}</div>              
<div class="info-row"><strong>Ordered On:</strong> ${date}</div>
            <div class="floor-table"><strong>${floor_no}</strong> | <strong>${table_no}</strong></div>
          </div>

          <div class="section-title">Order Items</div>
          <div class="items-header">
            <div>ITEM</div>
            <div style="display: flex; justify-content: space-between; min-width: 120px;">
              <div>RATE</div>
              <div>QTY</div>
              <div>AMT</div>
            </div>
          </div>
          ${itemsHtml}

          <div class="section-title">Payment Summary</div>
          ${paymentsHtml}

          <div class="final-total">
            <div>Grand Total</div> <div>₹${Number.parseFloat(finalTotal.toString()).toFixed(2)}</div>
          </div>
          <div class="payment-mode">
              <div>Payment Mode</div> <div style="text-transform: uppercase;">${formattedPaymentMethod}</div>
          </div>

          <div class="footer">
            Thank you!<br>
            Please visit us again!
          </div>
        </div>
        <script>
          setTimeout(() => {
            window.print();
            setTimeout(() => window.close(), 500);
          }, 200);
        </script>
      </body>
    </html>
  `)

  printWindow.document.close()
  printWindow.focus()
}

 closeOrder = async (payment_method) => {
  try {
    const tempId = this.state.SelectedTableOrderData?.id
    if (!tempId) {
      console.error("No order ID found in SelectedTableOrderData")
      return window.Alert({ title: "No active order found", icon: "error" })
    }

    const orderId = tempId
    const url = URL_PATH.finishOrder("completed", orderId, payment_method)

    // Complete the order first
    const response1 = await API(this, "get", url)
    const { status, message } = response1

    if (status === "success") {
      // Then get order details
      const response2 = await API(this, "get", URL_PATH.OrderHistoryDetail(tempId))
      const { status: status2, message: message2, data } = response2

      this.setState({ loading: false })

      if (status2 === "error") {
        return window.Alert({ title: message2, icon: "error" })
      }
      
      // Extract and set order details
      const {
        hotel_name,
        hotel_address,
        logo,
        hotel_phones,
        order_id,
        order_type,
        date,
        coupon,
        order_status,
        items,
        total,
        payments,
        gst_number,
        fssai_number,
        customer_name,
        payment_method,
        floor_no,
        table_no,
      } = data

      // Show receipt in modal instead of printing directly
      this.printReceipt({
        hotel_name,
        address: hotel_address,
        hotel_phones,
        gst_number,
        fssai_number,
        customer_name,
        order_id,
        order_type,
        date,
        items,
        payments,
        payment_method,
        floor_no,
        table_no,
        logo,
      })

      // Deselect the table and refresh table list
      this.deSelectTable(() => {
        this.getTables(this.state.selectedFloorId)
      })
    } else {
      this.openModal("error", "Error", message)
    }
  } catch (error) {
    console.error("Error in closeOrder:", error)
    this.openModal("error", "Error", "Something went wrong!")
  }
}

  cancelOrderApi = async () => {
    const order_id = this.state.SelectedTableOrderData.id

    const { status, message, data } = await API(this, "get", URL_PATH.cancelOrder(order_id))
    console.log("tada0", data)
    if (status == "error") {
      return this.openModal("error", "Error", message)
    }

    this.deSelectTable(() => {
      this.getTables(this.state.selectedFloorId)
    })
  }
  handleCancelOrder = () => {
    this.openConfirmationModal()
  }

  handleConfirmCancelOrder = () => {
    this.closeConfirmationModal()
    this.cancelOrderApi()
  }

  EditItem = ({ item, index }) => {

    console.log("EditItem itemwww", this.state.CartData)
    // Fix the destructuring and handle both special and normal items
    const { menu_id, name, description, amount, rate, cutPrice, quantity, specialItem } = item
    const displayName = name || description // Use name or fallback to description

    return (
      <tr style={{}}>
        <td style={{ padding: "12px" }}>
          {displayName}

          {/* Display special item details if available */}
          {specialItem && (
            <div style={{ fontSize: "12px", color: "#aaa", marginTop: "4px" }}>
              {/* Variation details */}
              {specialItem.variation_data && Object.entries(specialItem.variation_data).map(([key, value]) => (
                <div key={key}>
                  {key}: <span style={{ fontWeight: "500" }}>{value}</span>
                </div>
              ))}

              {/* Add-ons */}
              {specialItem.add_ons_data && specialItem.add_ons_data.length > 0 && (
                <div style={{ marginTop: "2px" }}>
                  Add-ons: {specialItem.add_ons_data.map((addon, i) => (
                    <span key={i}>
                      {addon.option_name || addon.name}
                      {addon.price && ` (₹${addon.price})`}
                      {i !== specialItem.add_ons_data.length - 1 && ", "}
                    </span>
                  ))}
                </div>
              )}

              {/* Special request */}
              {specialItem.special_request && (
                <div style={{ marginTop: "2px", fontStyle: "italic" }}>
                  Note: {specialItem.special_request}
                </div>
              )}
            </div>
          )}
        </td>

        <td style={{ padding: "12px" }}>
          <span>&#8377;</span>
          {amount}
        </td>

        <td
          style={{
            padding: "12px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
            gap: "20px", // Increased spacing between buttons and quantity
          }}
        >
          <button
            style={{
              border: "none",
              backgroundColor: Colors.pageBgColor,
              fontWeight: "bold",
              color: "white",
              padding: "8px", // Increased padding
              borderRadius: "4px",
              cursor: "pointer",
              width: "40px", // Increased width
              height: "40px", // Increased height
              textAlign: "center",
            }}
            onClick={() => {
              if (quantity == 0) return

              const { CartData } = this.state
              CartData[index].quantity = quantity - 1
              this.setState({ CartData })
            }}
          >
            -
          </button>
          <div
            style={{
              width: "40px", // Increased width
              textAlign: "center",
              padding: "8px", // Increased padding
              border: "1px solid rgba(0,0,0,0.3)",
              backgroundColor: Colors.rootBgColor,
            }}
          >
            {quantity}
          </div>
          <button
            onClick={() => {
              const { CartData } = this.state
              CartData[index].quantity = quantity + 1
              this.setState({ CartData })
            }}
            style={{
              border: "none",
              backgroundColor: Colors.pageBgColor,
              fontWeight: "bold",
              color: "white",
              padding: "8px", // Increased padding
              borderRadius: "4px",
              cursor: "pointer",
              width: "40px", // Increased width
              height: "40px", // Increased height
              textAlign: "center",
            }}
          >
            +
          </button>
        </td>

        <td style={{ padding: "12px" }}>{rate * quantity}</td>
        <td
          style={{
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#BB0A21",
            borderRadius: "4px",
            height: "35px", // Set a specific height
            display: "flex", // Ensures content stays centered
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            this.removeFromCart(item)
          }}
        >
          <i className="fa fa-trash" style={{ color: "white", fontSize: "16px" }}></i>
        </td>
      </tr>
    )
  }

  updateOrder = async () => {
    const { CartData } = this.state

    const items = CartData.map((item) => {
      return {
        menu_id: item.menu_id,
        quantity: item.quantity,
      }
    })

    const formdata = {}

    formdata.items = items
    formdata.order_id = this.state.hotelorderid

    console.log("--------------updateOrder() formdata is : " + JSON.stringify(formdata))

    const response = await API(this, "post", URL_PATH.updateOrder, formdata)

    const { status, message, data } = response

    if (status == "error") {
      return this.openModal("error", "Error", message)
    }
    this.setState({ editOrderVisible: false })
    this.getCheckoutDetails()
  }

  render() {
    const { isModalOpen, modalType, modalTitle, modalMessage, modalButtonText } = this.state
    const { isConfirmationModalOpen } = this.state


    return (
      <div className="container-fluid px-0 px-md-2" style={{ paddingRight: "0px" }}>
        {/* switch table popup */}
        <AutoPrintKOT
          ref={this.autoPrintRef}
          showToast={this.showToast}
          onPrintError={this.handlePrintError}
        />
        {this.state.switchTableOpen && (
          <SwitchTable
            onCancel={() => {
              this.setState({ switchTableOpen: false })
            }}
            handleSuccess={this.handleSuccess}
            isOpen={this.state.switchTableOpen}
            apiCall={this.apiCall}
            orderId={this.state.selectedTokenOrderId}
          />
        )}

        {/* Special Product Modal */}
        <SpecialProductModal
          open={this.state.specialProductModalOpen}
          onClose={this.closeSpecialProductModal}
          item={this.state.selectedSpecialProduct}
          onAddToCart={this.addSpecialProductToCart}
          hotelId={this.props.selectedHotelId.id}
        />

        {/* 2 section left cat menu and right active table order */}
        <div className="d-flex flex-column flex-lg-row">
          {/* left side tables search catagory and menu*/}
          <Box
            style={{
              flex: 7,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
            className="mb-3 mb-lg-0"
          >
            {/* Floors */}

            <Floors
              data={this.state.floors}
              selectedFloorId={this.state.selectedFloorId}
              onClick={(item, index) => {
                this.deSelectTable()

                const { floors } = this.state
                console.log("floors,", floors)
                // if(floors === "floors")

                // floors[index].call_waiter = 0

                this.setState(
                  {
                    selectedFloorId: item.id,
                    tables: [],
                    floors,
                  },
                  () => this.getTables(item.id), this.getHotelCatagoriesWithMenu(item.id)
                )
              }}
            />

            {/* active floor tables */}

            <Tables
              data={this.state.tables}
              selectedTableId={this.state.selectedTableId}
              handleClick={(item, index) => {
                const { id, table_no } = item;
                this.clearCart();
                this.deSelectTable();

                this.setState(
                  {
                    selectedTable: item,
                    selectedTableId: id,
                    selectedTableNo: table_no,
                  },
                  () => this.getTableOrders(item),
                );
              }}
              onHover={async (table) => {
                try {
                  // First get the active order for the table
                  const orderResponse = await API(this, "get", URL_PATH.getTableActiveOrders(table.id));
                  if (orderResponse.status === "success" && orderResponse.data.id) {
                    const orderId = orderResponse.data.id;
                    const response = await API(this, "get", URL_PATH.getCurrentOrderStatusOrders(orderId));
                    if (response.status === "success") {
                      return {
                        duration: response.data.duration_formatted || "0 min",
                        total: response.data.kot_total_price || 0,
                        currency: this.state.currency,
                        status: response.data.order_status || "pending",
                        kotStatus: response.data.kot_statuses?.[0] || "pending" // Updated to match API response
                      };
                    }
                  }
                } catch (error) {
                  console.error("Error fetching table duration:", error);
                  return null;
                }
                return null;
              }}
            />

            {/* search catagory menu*/}

            <SearchFood
              search={this.state.search}
              searchResult={this.state.searchResult}
              handleChange={(value) => {
                this.setState({ search: value }, () => {
                  this.search()
                })
              }}
              addToCart={(item) => {
                this.addToCart(item)
              }}
              visible={this.state.selectedTableId}
            />

            {/* catagory and menu */}
            {this.state.selectedTableId != 0 && (
              <Grid container spacing={2}>
                {/* Categories */}
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // Allow wrapping to the next row
                      gap: "10px", // Add spacing between cards
                      marginBottom: "10px", // Add some space below
                      msOverflowStyle: "none", // Hide scrollbar in IE
                      scrollbarWidth: "none", // Hide scrollbar in Firefox
                    }}
                  >
                    {this.state.catagoriesWithMenu.map((item, index) => {
                      if (item.hotel_menu.length == 0) return null

                      return (
                        <div
                          key={index}
                          className="category-card flex-[0_0_calc(10%_-_10px)] max-w-[calc(10%_-_10px)] sm:flex-[0_0_calc(25%_-_10px)] sm:max-w-[calc(25%_-_10px)] md:flex-[0_0_calc(20%_-_10px)] md:max-w-[calc(20%_-_10px)] lg:flex-[0_0_calc(12.5%_-_10px)] lg:max-w-[calc(12.5%_-_10px)]"
                        >
                          <CategoryCard
                            item={item}
                            selectedCatagoryIndex={this.state.selectedCatagoryIndex}
                            selectCategory={(index) => {
                              this.setState({ selectedCatagoryIndex: index })
                            }}
                            index={index}
                          />
                        </div>
                      )
                    })}
                  </div>
                </Grid>

                {/* Menu items */}
                <Grid item xs={12}>
                  {this.state.catagoriesWithMenu.length > 0 && (
                    <Box>
                      {this.state.search.length > 0 && (
                        <Box
                          sx={{
                            padding: "2px",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span>Search Result: {this.state.search}</span>
                          <Button
                            onClick={() => {
                              this.setState({ search: "" })
                            }}
                          >
                            Clear
                          </Button>
                        </Box>
                      )}

                      <div
                        className="container-fluid food-scroll"
                        style={{
                          maxHeight: "calc(100vh - 400px)", // Adjust based on other elements
                          overflowY: "auto",
                          overflowX: "hidden",
                          msOverflowStyle: "none", // Hide scrollbar in IE
                          scrollbarWidth: "none", // Hide scrollbar in Firefox
                        }}
                      >
                        <div className="row">
                          {this.state.search.length > 0
                            ? this.state.searchResult.map((item, index) => (
                              <div key={index} className="food-card col-6 col-sm-6 col-md-4 col-lg-3 mb-3">
                                <FoodCard
                                  item={item}
                                  addToCart={this.addToCart}
                                  openSpecialProductModal={this.openSpecialProductModal}
                                />
                              </div>
                            ))
                            : this.state.catagoriesWithMenu[this.state.selectedCatagoryIndex].hotel_menu
                              .sort((a, b) => a.menu_name.localeCompare(b.menu_name))
                              .map((item, index) => (
                                <div key={index} className="food-card col-6 col-sm-6 col-md-4 col-lg-3 mb-3">
                                  <FoodCard
                                    item={item}
                                    addToCart={this.addToCart}
                                    openSpecialProductModal={this.openSpecialProductModal}
                                  />
                                </div>
                              ),
                              )}
                        </div>
                      </div>
                    </Box>
                  )}
                </Grid>
              </Grid>
            )}
          </Box>

          {/* right side bill*/}
          {this.state.selectedTable?.table_no && (
            <div
              style={{
                display: "flex",
                flex: 3,
                height: "calc(87vh - 20px)", // Take almost full viewport height
                overflow: "hidden", // Prevent scrolling on the entire container
                margin: "0px 0px 0px 10px",
                flexDirection: "column",
                borderRadius: "4px",
                border: "1px solid rgb(80, 80, 80)",
                position: "relative", // Ensure the buttons are positioned relative to this container
              }}
              className="bill-section"
            >
              {/* Table No Section */}
              <Grid
                container
                sx={{
                  padding: "10px",
                  backgroundColor: "#041A29",
                  color: "white",
                  marginBottom: "10px",
                }}
                alignItems="space-between"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
   
                  {this.state.selectedTable.floor_no || this.state.selectedTable.hotel_floor?.floor_no
                    ? `${Capitalize(this.state.selectedTable.floor_no || this.state.selectedTable.hotel_floor.floor_no)} | ${this.state.selectedTable.table_no}`
                    : this.state.selectedTable.table_no}                </Grid>
                {this.state.selectedTableVacant && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      onClick={() => {
                        this.setState({
                          switchTableOpen: true,
                          selectedTokenOrderId: this.state.SelectedTableOrderData.id,
                        })
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#FFC857",
                        color: "black",
                        borderRadius: "4px",
                        padding: "6px",
                        fontWeight: "700",
                      }}
                    >
                      Change Table
                    </Box>
                    {/* <Box  
                      onClick={() => {
                        this.setState({ isConfirmationModalOpen: true })
                      }}
                      style={{
                        cursor: "pointer",
                        marginLeft: "15px",
                        color: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "background 0.3s ease, transform 0.2s",
                        background: "#BB0A21",
                      }}
                      // onMouseEnter={(e) => (e.currentTarget.style.background = "red")}
                      // onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                      title="Cancel Order"
                    >
                      <i className="fa fa-trash" style={{ fontSize: "18px" }}></i>

                      {this.state?.isConfirmationModalOpen && (
                        <ConfirmationModal
                          isOpen={this.state.isConfirmationModalOpen}
                          onConfirm={this.handleConfirmCancelOrder}
                          onCancel={() => this.setState({ isConfirmationModalOpen: false })}
                          title="Are you sure?"
                          message="You want to cancel this order?"
                          confirmText="Yes, Cancel it!"
                          cancelText="No"
                        />
                      )}
                    </Box> */}
                  </Grid>
                )}
              </Grid>

              {/* Scrollable Section */}
              <div
                style={{
                  flex: 1,
                  overflowY: "auto", // Enable scrolling for this section
                  padding: "0 10px", // Add padding to match the design
                  scrollbarWidth: "none" /* Firefox */,
                  msOverflowStyle: "none",
                  height: "calc(100% - 120px)", // Adjust based on header and footer heights
                }}
                className="bill-scroll"
              >
                {/* Add new menu */}
                {this.state.cartMode == "add" && (
                  <>
                    {this.OrderDetails()}

                    {this.state.closeOrderVisible == false && (
                      <>
                        {this.state.kot.length > 0 && (
                          <>
                            <Box className="mt-2 mx-2">
                              <p className="mb-2">KOT</p>
                            </Box>

                            {/* KOT list */}
                            <div className="kot-list mx-2">
                              {this.state.kot.map((item, index) => {
                                console.log("itemitem", item)
                                const { id, kot_items, expanded = false } = item
                                const statusColor =
                                  item.status == "pending"
                                    ? "blue"
                                    : item.status == "completed"
                                      ? "green"
                                      : item.status == "cancelled"
                                        ? "red"
                                        : "default"
                                const order_time = "Order Time: " + moment(item.created_at).format("hh:mm A")
                                const order_time_ago = moment(item.created_at).fromNow()

                                return (
                                  <Box
                                    sx={{
                                      borderWidth: 1,
                                      borderColor: Colors.pageBgColor,
                                      borderStyle: "solid",
                                      marginTop: "5px",
                                    }}
                                    key={item.id}
                                    className="kot-item"
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignContent: "center",
                                        alignItems: "center",
                                        backgroundColor: getKOTBgColor(item.status),
                                        paddingLeft: "10px",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span
                                        onClick={() => {
                                          console.log("Iteeem", item)
                                          const kot = [...this.state.kot]
                                          kot[index].expanded = !kot[index].expanded
                                          this.setState({ kot: kot })
                                        }}
                                        style={{
                                          flex: 1,
                                          color: getKOTTextColor(item.status),
                                        }}
                                      >
                                        KOT No : {item.kot_number}
                                      </span>

                                      {/* KOT status */}
                                      <FormControl
                                        variant="outlined"
                                        sx={{
                                          minWidth: 120,
                                        }}
                                      >
                                        <Select
                                          value={item.status}
                                          onChange={(e) => this.saveKOTStatus(item, e.target.value)}
                                          sx={{
                                            minWidth: 120,
                                            height: "42px",
                                            color: getKOTTextColor(item.status),
                                            "& .MuiSelect-icon": {
                                              color: "black",
                                            },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                "& .MuiMenuItem-root": {
                                                  backgroundColor: "#041A29",
                                                  color: "white",
                                                },
                                                "& .MuiMenuItem-root.Mui-disabled": {
                                                  opacity: 0.5,
                                                },
                                              },
                                            },
                                          }}
                                        >
                                          <MenuItem
                                            value="pending"
                                            disabled={item.status !== "pending"} // Disable if not current status
                                          >
                                            PENDING
                                          </MenuItem>
                                          <MenuItem
                                            value="cooking"
                                            disabled={item.status === "served"} // Disable only if already served
                                          >
                                            COOKING
                                          </MenuItem>
                                          <MenuItem
                                            value="served"
                                            disabled={false} // Never disable served option
                                          >
                                            SERVED
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </div>

                                    {expanded && (
                                      <Box>
                                        <Box
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            padding: "5px 10px",
                                          }}
                                        >
                                          <span>{order_time}</span>
                                          <span>{order_time_ago}</span>
                                        </Box>
                                        <div className="item-list">
                                          {item.kot_items.map((item, index) => this.RenderItems({ item, index }))}
                                        </div>
                                      </Box>
                                    )}
                                  </Box>
                                )
                              })}
                            </div>
                            <hr />
                          </>
                        )}

                        {this.state.cart.length > 0 && (
                          <Box className="mt-2">
                            <p>Cart</p>
                          </Box>
                        )}
                        {this.state.cart.length > 0 && (
                          <table className="table table-borderless">
                            <thead>
                              <tr
                                style={{
                                  borderBottom: "1px solid black",
                                }}
                              >
                                <th>Item</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th>Total</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody
                              style={{
                                borderBottom: "1px solid black",
                              }}
                            >
                              {this.state.cart.map((item, index) => {
                                // Determine which price to use (area price or menu price)
                                const itemPrice = item.currentPrice || item.menu_price;

                                return (
                                  <tr key={index}>
                                    <td>
                                      {item.menu_name}
                                      {item.isSpecial && (
                                        <div
                                          style={{
                                            fontSize: "0.8em",
                                            color: "#aaa",
                                            marginTop: "2px",
                                          }}
                                        >
                                          {item.selectedAttributes &&
                                            item.selectedAttributes.map((attr, i) => (
                                              <div key={i}>
                                                {attr.name}: {attr.value}
                                              </div>
                                            ))}
                                          {item.selectedAddons &&
                                            item.selectedAddons.map((addon, i) => (
                                              <div key={i}>
                                                {addon.fieldName}: {addon.options.map((opt) => opt.name).join(", ")}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <span>&#8377;</span>
                                      {item.isSpecial
                                        ? item.itemTotalPrice
                                        : itemPrice}
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        alignContent: "center",
                                      }}
                                    >
                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: Colors.pageBgColor,
                                          fontWeight: "bold",
                                          color: "white",
                                          padding: "5px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          width: "30px",
                                          height: "30px",
                                          textAlign: "center",
                                        }}
                                        onClick={() => {
                                          this.decreaseQuantity(item)
                                        }}
                                      >
                                        -
                                      </button>
                                      <div
                                        style={{
                                          width: "30px",
                                          textAlign: "center",
                                          padding: "0px 5px",
                                          border: "1px solid rgba(0,0,0,0.3)",
                                          backgroundColor: Colors.rootBgColor,
                                        }}
                                      >
                                        {item.quantity}
                                      </div>
                                      <button
                                        // onClick={() => {
                                        //   if (item.isSpecial) {
                                        //     // For special items, we need to open the modal again
                                        //     this.openSpecialProductModal(item)
                                        //   } else {
                                        //     this.addToCart(item)
                                        //   }
                                        // }}
                                        onClick={() => {

                                          this.addToCart(item)

                                        }}
                                        style={{
                                          border: "none",
                                          backgroundColor: Colors.pageBgColor,
                                          fontWeight: "bold",
                                          color: "white",
                                          padding: "5px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          width: "30px",
                                          height: "30px",
                                          textAlign: "center",
                                        }}
                                      >
                                        +
                                      </button>
                                    </td>
                                    <td>₹{item.isSpecial ? item.itemTotalPrice * item.quantity : itemPrice * item.quantity}</td>
                                    <td
                                      onClick={() => {
                                        this.removeFromCart(item)
                                      }}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        )}
                        {this.state.cart.length > 0 && <hr />}
                      </>
                    )}
                  </>
                )}

                {/* Payment Calculations */}
                {this.state.closeOrderVisible && (
                  <Box
                    sx={{
                      paddingLeft: "8px",
                      paddingRight: "8px",
                    }}
                  >
                    {/* <p style={{ marginLeft: "5px", fontWeight: "bold" }}>Your Items</p> */}

                    {this.state.CartData && this.state.CartData.length > 0 ? (

                      this.state.CartData.map((item, index) => {
                        if (this.state.editOrderVisible) return <this.EditItem item={item} index={index} key={index} />

                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              width: "100%",
                              alignSelf: "center",
                              padding: "10px",
                              paddingBottom: "20px",
                              alignItems: "flex-start",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: "#041A29",
                                  height: "30px",
                                  width: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <p
                                  style={{
                                    color: "white",
                                    fontSize: "16px",
                                    margin: 0,
                                  }}
                                >
                                  {index + 1}
                                </p>
                              </div>
                              <div style={{ marginLeft: "10px" }}>
                                <p style={{ fontSize: "16px", fontWeight: "bold" }}>{item.name}</p>

                                {/* Variation Details */}
                                {item.specialItem?.variation_data && (
                                  <div style={{ color: "#b0bec5", fontSize: "14px" }}>
                                    {Object.entries(item.specialItem.variation_data).map(([key, value]) => (
                                      <div key={key}>
                                        {key}: <b>{value}</b>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* Add-ons */}
                                {/* {item.specialItem?.add_ons_data?.length > 0 && (
                                  <div style={{ marginTop: "2px", color: "#80cbc4", fontSize: "14px" }}>
                                    Add-ons:{" "}
                                    {item.specialItem.add_ons_data.map((addon, i) => (
                                      <span key={i}>
                                        {addon.addon_field_name || addon.name}: {addon.option_name || addon.value}
                                        {addon.price && ` (${this.state.currency}${addon.price})`}
                                        {i !== item.specialItem.add_ons_data.length - 1 && ", "}
                                      </span>
                                    ))}
                                  </div>
                                )} */}
                                {item.specialItem &&
                                  typeof item.specialItem === 'object' &&
                                  item.specialItem.add_ons_data &&
                                  Object.keys(item.specialItem.add_ons_data).length > 0 && (
                                    <div style={{ marginTop: "2px", color: "#b0bec5", fontSize: "14px" }}>
                                      Add-ons:{" "}
                                      {Object.entries(item.specialItem.add_ons_data).map(([name, price], i, arr) => (
                                        <span key={i}>
                                          {name}: ₹{price}
                                          {i !== arr.length - 1 && ", "}
                                        </span>
                                      ))}
                                    </div>
                                  )}




                                {/* Special Request */}
                                {item.specialItem?.special_request && (
                                  <div
                                    style={{
                                      marginTop: "2px",
                                      // fontStyle: "italic",
                                      fontSize: "14px",
                                      color: "#b0bec5",
                                    }}
                                  >
                                    Special Request: {item.specialItem.special_request}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div style={{ marginTop: "2px" }}>
                              <p style={{ color: "white", fontSize: "15px" }}>
                                {"₹"}
                                {item.amount}
                              </p>
                            </div>
                          </div>
                        )
                      })
                    ) : (
                      <div style={{ padding: "20px", textAlign: "center", color: "#aaa" }}>No items in cart</div>
                    )}

                    {this.state.editOrderVisible == false && (
                      <>
                        {/* Total GST, SPC Discount, etc. */}
                        <div
                          style={{
                            borderBottom: "solid 2px black",
                          }}
                        >
                          {this.state.payments.map((item, index) => (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                margin: "2px 5px",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: item.prefix == "-" ? Colors.mutedWhite : Colors.white,
                                  fontSize: index == this.state.payments.length - 1 ? 16 : 14,
                                }}
                              >
                                {item.key}
                              </p>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: item.prefix == "-" ? Colors.mutedWhite : Colors.white,
                                  fontSize: index == this.state.payments.length - 1 ? 16 : 14,
                                }}
                              >
                                {item.prefix ?? ""}
                                {getCurrency(this.state.currency)} {item.value}
                              </p>
                            </div>
                          ))}

                          <Grid
                            container
                            spacing={2}
                            style={{
                              padding: "5px 5px 5px 5px",
                              alignItems: "center",
                            }}
                          >
                            <Grid item xs={3}>
                            </Grid>
                            <Grid item xs={12}>
                              <FormControl style={{ width: "100%" }}>
                                <TextField
                                  type="number"
                                  value={this.state.extraDiscount}
                                  placeholder="Ex. Disc. (%)"
                                  onChange={(e) => {
                                    if (e.target.value === "") return this.setState({ extraDiscount: "" });
                                    if (isNaN(e.target.value)) return;
                                    if (e.target.value > 100) return;
                                    this.setState({ extraDiscount: e.target.value });
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Button
                                          variant="contained"
                                          size="small"
                                          sx={{
                                            backgroundColor: Colors.greenColor,
                                            fontWeight: "700",
                                            color: "white",
                                            ml: 1,
                                            minWidth: "60px",
                                            height: "36px",
                                            padding: "4px 12px",
                                            "&:hover": {
                                              backgroundColor: Colors.greenColor,
                                            },
                                          }}
                                          onClick={() => this.applyExtraDiscount()}
                                        >
                                          Apply
                                        </Button>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </FormControl>



                              <FormControl style={{ width: "100%" }}>
                                <TextField
                                  type="number"
                                  value={this.state.waiterTip}
                                  placeholder="Add tip"
                                  onChange={(e) => {
                                    if (e.target.value === "") return this.setState({ waiterTip: "" });
                                    if (isNaN(e.target.value)) return;
                                    this.setState({ waiterTip: e.target.value });
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Button
                                          variant="contained"
                                          size="small"
                                          sx={{
                                            backgroundColor: Colors.greenColor,
                                            fontWeight: "700",
                                            color: "white",
                                            ml: 1,
                                            minWidth: "60px",
                                            height: "36px",
                                            padding: "4px 12px",
                                            "&:hover": {
                                              backgroundColor: Colors.greenColor,
                                            },
                                          }}
                                          onClick={() => this.applyWaiterTip()}
                                        >
                                          Add waiter tip
                                        </Button>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </FormControl>
                            </Grid>

                          </Grid>
                        </div>

                        {/* Payment Mode */}
                        <Box
                          sx={{
                            margin: "5px 5px 5px 5px",
                          }}
                        >
                          <Grid
                            container
                            spacing={0}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* <Grid item sx={6}>
                              <p>Payment Mode</p>
                            </Grid> */}
                            <Grid item xs={12}>
                              <Select
                                style={{
                                  width: "100%",
                                }}
                                value={this.state.paymentMode}
                                onChange={(e) => {
                                  this.setState({ paymentMode: e.target.value })
                                }}
                              >
                                {this.state.paymentModes.map((item, index) => (
                                  <MenuItem value={item.value}>{item.label}</MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Edit and Complete Order Buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: "12px",
                            fontWeight: "bold",
                            padding: "5px",
                            position: "sticky",

                            bottom: 0,
                            // marginBottom: "10px",
                            zIndex: 1,

                            overflow: "hidden", // Ensure no scroll is applied to the box
                            maxHeight: "60px",
                          }}
                        >
                          <Button
                            variant="conatined"
                            sx={{
                              backgroundColor: Colors.primary,
                              textAllign: "center",
                              flex: 1,
                              marginRight: "5px",
                              color: "black",
                              fontWeight: "700",
                              "&:hover": {
                                backgroundColor: Colors.primary,
                              },
                            }}
                            onClick={() => {
                              this.setState({ editOrderVisible: true })
                            }}
                          >
                            Edit Order
                          </Button>
                          <Button
                            variant="conatined"
                            sx={{
                              backgroundColor: Colors.greenColor,
                              textAllign: "center",
                              flex: 1,
                              marginLeft: "5px",
                              color: "white",
                              fontWeight: "700",
                              "&:hover": {
                                backgroundColor: Colors.greenColor,
                              },
                            }}
                            onClick={() => {
                              this.closeOrder(this.state.paymentMode)
                            }}
                          >
                            COMPLETE ORDER
                          </Button>
                        </Box>
                      </>
                    )}

                    {this.state.editOrderVisible && (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          marginTop: "12px",
                          fontWeight: "bold",
                          padding: "5px",
                          position: "sticky",

                          bottom: 0,
                          zIndex: 1,

                          overflow: "hidden",
                          maxHeight: "60px",
                        }}
                      >
                        <Button
                          variant="conatined"
                          sx={{
                            backgroundColor: "#BB0A21",
                            textAllign: "center",
                            flex: 1,
                            marginRight: "5px",
                            color: "white",
                            fontWeight: "700",
                            "&:hover": {
                              backgroundColor: "#BB0A21",
                            },
                          }}
                          onClick={() => {
                            this.setState({ editOrderVisible: false })
                            this.getCheckoutDetails()
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="conatined"
                          sx={{
                            backgroundColor: "#00A651",
                            textAllign: "center",
                            flex: 1,
                            marginLeft: "5px",
                            color: "white",
                            fontWeight: "700",
                            "&:hover": {
                              backgroundColor: "#00A651",
                            },
                          }}
                          onClick={() => {
                            this.updateOrder()
                          }}
                        >
                          Update Order
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
              </div>
              {this.state.cart.length > 0 && (
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  position: "sticky",
                  bottom: 0,
                  marginBottom: "10px",
                  zIndex: 1,
                  padding: "0 10px",
                }}>


                  {/* <button
                    style={{
                      flex: 1, // Takes equal space
                      padding: "10px",
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontWeight: "700",
                    }}
                    className="btn btn-success"
                    onClick={() => {
                      this.saveOrder(false); // Pass false to indicate print is not needed
                    }}
                  >
                    Send KOT
                  </button> */}
                  <button
                    style={{
                      flex: 1, // Takes equal space
                      padding: "10px",
                      backgroundColor: "#02111B",
                      color: "white",

                      borderRadius: "4px",
                      borderWidth: "1px",
                      borderColor: " #28a745",
                      cursor: "pointer",
                      fontWeight: "700",
                    }}
                    className="btn btn-success"
                    onClick={() => {
                      this.saveOrder(true); // Pass true to indicate print is needed
                    }}
                  >
                    Send and Print KOT
                  </button>
                </div>



              )}
              {/* Fixed Buttons at the Bottom */}
        {this.state.in_house_payment && this.state.orderInfo ? (
  // Show Accept Payment button when payment request exists
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      padding: "8px",
      justifyContent: "flex-end",
      position: "sticky",
      bottom: 0,
      zIndex: 1,
    }}
    className="mt-auto"
  >
    <button
      className="btn"
      onClick={async () => {
        try {
          console.log("Payment button pressed with orderInfo:", this.state.orderInfo);
          
          if (!this.state.orderInfo || !this.state.orderInfo.order_id) {
            console.error("Invalid order data");
            this.props.okDialog("Payment information is incomplete");
            return;
          }

          const { order_id, payment_method = "cash", amount } = this.state.orderInfo;
          console.log(`Processing payment for order ${order_id} (${payment_method})`);

          // First API call - mark payment received
          const paymentResponse = await API(
            this,
            "post",
            URL_PATH.paymentReceivedForOrder,
            {
              order_id: order_id,
              payment_method: payment_method,
              amount: amount || this.state.SelectedTableOrderData?.order_grand_total
            }
          );
          console.log("Processing payment for orde",paymentResponse);

          if (paymentResponse.status === "error") {
            throw new Error(paymentResponse.message || "Payment failed");
          }

          // Second API call - send invoice
          await API(this, "post", URL_PATH.sendInvoice(order_id));

          // Update state and refresh
          this.setState({
            PaymentRequestDialog: false,
            in_house_payment: false,
            orderInfo: null
          }, () => {
            this.getTableOrders(this.state.selectedTableId);
          });

          if (this.paymentTimeout) clearTimeout(this.paymentTimeout);

        } catch (error) {
          console.error("Payment processing error:", error);
          this.props.okDialog(error.message || "Payment failed");
        }
      }}
      style={{
        cursor: "pointer",
        color: "white",
        backgroundColor: Colors.greenColor,
        borderRadius: "4px",
        padding: "6px 15px",
        fontWeight: "700",
        textAlign: "center",
        flex: "1",
      }}
    >
      ACCEPT PAYMENT ({this.state.orderInfo?.payment_method?.toUpperCase() || 'CASH'})
    </button>
  </div>
) : (
  // Show Cancel Order and Checkout buttons when no payment request
  !this.state.in_house_payment && this.state.kot.length > 0 && this.state.closeOrderVisible == false && (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        padding: "8px",
        justifyContent: "flex-end",
        position: "sticky",
        bottom: 0,
        zIndex: 1,
      }}
      className="mt-auto"
    >
      {/* Cancel Order Button */}
      <button
        className="btn"
        onClick={this.handleCancelOrder}
        style={{
          cursor: "pointer",
          color: "white",
          backgroundColor: "#BB0A21",
          borderRadius: "4px",
          padding: "6px 15px",
          fontWeight: "700",
          textAlign: "center",
          flex: "1",
        }}
      >
        CANCEL ORDER
      </button>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onConfirm={this.handleConfirmCancelOrder}
        onCancel={this.closeConfirmationModal}
        title="Are you sure?"
        message="You want to cancel this order?"
        confirmText="Yes, Cancel it!"
        cancelText="No"
      />
      {/* Checkout Button */}
      <button
        className="btn"
        style={{
          fontWeight: "700",
          backgroundColor: Colors.greenColor,
          color: "white",
          flex: 1,
          padding: "6px",
          textAlign: "center",
        }}
        onClick={() => {
          const hasUnservedKOTs = this.state.kot.some((kotItem) => kotItem.status !== "served");
          if (hasUnservedKOTs) {
            this.showToast("Please serve the food before checkout", "error");
            return;
          }
          this.checkout();
        }}
      >
        CHECKOUT
      </button>
    </div>
  )
)}
            </div>
          )}
        </div>

        {this.state.kotPrintInProgress && this.renderKot()}
        {this.state.billPrintInProgress && this.renderBill()}
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        <style>
          {`
            .category-scroll::-webkit-scrollbar, .food-scroll::-webkit-scrollbar {
              display: none;
            }
            .bill-scroll::-webkit-scrollbar {
              display: none;
            }
            
            @media (max-width: 992px) {
              .bill-section {
                height: auto !important;
                min-height: 500px;
                margin-left: 0 !important;
                margin-top: 10px;
              }
            }
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.waiter-button:not(.sent):hover {
  animation: pulse 1.5s ease infinite;
}
          `}
        </style>
      </div>
    )
  }
}
const styles = {
  actionButtonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    backgroundColor: '#041A29',
    borderRadius: '8px',
    margin: '12px 0'
  },
  waiterButton: {
    backgroundColor: '#07070A',
    border: '1px solid #FFC857',
    borderRadius: '8px',
    padding: '14px 20px',
    width: '100%',
    maxWidth: '280px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      backgroundColor: '#0A1E30',
      boxShadow: '0 0 0 2px rgba(255, 200, 87, 0.3)'
    }
  },
  waiterSentButton: {
    backgroundColor: '#041A29',
    border: '1px solid #00A651',
    borderRadius: '8px',
    padding: '14px 20px',
    width: '100%',
    maxWidth: '280px',
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'inset 0 0 8px rgba(0, 166, 81, 0.2)'
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  iconContainer: {
    position: 'relative',
    marginRight: '14px'
  },
  waiterIcon: {
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: this.state.waiterSent ? 'rgba(0, 166, 81, 0.1)' : 'rgba(255, 200, 87, 0.1)',
    borderRadius: '50%',
    transition: 'all 0.3s ease'
  },
  checkmark: {
    position: 'absolute',
    bottom: '-4px',
    right: '-4px',
    backgroundColor: '#00A651',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    flex: 1
  },
  mainText: {
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '2px'
  },
  subText: {
    color: '#BB0A21',
    fontSize: '13px',
    fontWeight: '500',
    opacity: 0.9
  }
};

// CSS Animation


// CSS Animation (add to your stylesheet)

export default redux(DineInScreen)